<!-- <p-toast></p-toast> -->
<div class="app-verification-container mt-2">
    <!-- <p-card styleClass="p-card-shadow"> -->
    <div class="card dashboardTable">
        <!-- <h4>{{'LIST_OF_WATER_TANK_TO_BE_VERIFIED_(PFMS_MODULE)'| translate}}</h4> -->
        <p-toolbar styleClass="mb-4">
            <ng-template pTemplate="left">
                <!-- <button pButton icon="pi pi-fw pi-plus" label="Add Bank Details" (click)="openNew()"
                class="p-button-success"></button> -->
                <!-- <button pButton pRipple  icon="pi pi-trash" class="ml-4 p-button-danger" (click)="deleteSelectedProducts()" [disabled]="!selectedBankAccounts || !selectedBankAccounts.length"></button> -->
            </ng-template>
            <ng-template pTemplate="right">
                <!-- <p-fileUpload accept=".jpeg,.pdf,.jpg" mode="basic" [maxFileSize]="5000000" label="Import" chooseLabel="Import" class="mr-2 inline-block"></p-fileUpload> -->
                <button (click)="menu.toggle($event)" pButton pRipple label="{{'EXPORT'| translate}}"
                    icon="pi pi-upload" class="p-button-help"></button>
                <button (click)="refreshTable()" pButton pRipple label="{{'REFRESH'| translate}}" icon="pi pi-refresh"
                    class="p-button-info ml-3"></button>
                <p-menu #menu [popup]="true" [model]="appVerificationItems"></p-menu>
            </ng-template>

        </p-toolbar>
        <p-table #appVerificationTable [value]="tankData" [rows]="10" [paginator]="true" [globalFilterFields]="[
          'srNo',
          'appID',
          'FarmerName',
          'District',
          'Block',
          'Village',
          'Total_Area',
          'AgeOfApplication',
          'Pending_CompletedDays',
          'LandDetail',
          'DeptRemarks',
          'Status',
          'Status_Ar',
          'FinYear',
          'AssignedDate',
          'ActionDate',
          'UserType',
          'Coverage_Area',
          'NoOfBeneficiary'
        ]" responsiveLayout="scroll" [(selection)]="tankData" [rowHover]="true" dataKey="id"
            currentPageReportTemplate="{{'SHOWING'| translate}} {first} {{'TO'| translate}} {last} {{'OF'| translate}} {totalRecords} {{'ENTRIES'| translate}}"
            [showCurrentPageReport]="true" sortField="AssignedDate" [sortOrder]="1" [loading]="loading">
            <ng-template pTemplate="caption">
                <div class="flex align-items-center justify-content-between">
                    <h5 class="m-0">{{'LIST_OF_WATER_TANK_TO_BE_VERIFIED_(PFMS_MODULE)'| translate}}</h5>
                    <span class="p-input-icon-left">
                        <i class="pi pi-search"></i>
                        <input pInputText type="text"
                            (input)="appVerificationTable.filterGlobal($any($event.target).value, 'contains')"
                            placeholder="{{'SEARCH'| translate}}" />
                    </span>
                </div>
            </ng-template>
            <ng-template pTemplate="header">
                <tr>
                    <th pSortableColumn="">{{'VIEW_APPLICATION'| translate}}</th>
                    <!-- <th pSortableColumn="srNO">
              {{'S_NO'| translate}}
              <p-columnFilter type="text" field="srNO" display="menu"></p-columnFilter>
              <p-sortIcon field="srNO"></p-sortIcon>
            </th> -->

                    <th pSortableColumn="appID">
                        {{'APP_ID'| translate}}
                        <p-columnFilter type="text" field="appID" display="menu"></p-columnFilter>
                        <p-sortIcon field="appID"></p-sortIcon>
                    </th>

                    <th pSortableColumn="FarmerName">
                        {{'FARMER_NAME'| translate}}
                        <p-columnFilter type="text" field="FarmerName" display="menu"></p-columnFilter>
                        <p-sortIcon field="FarmerName"></p-sortIcon>
                    </th>

                    <th pSortableColumn="District">
                        {{'DISTRICT'| translate}}
                        <p-columnFilter type="text" field="District" display="menu"></p-columnFilter>
                        <p-sortIcon field="District"></p-sortIcon>
                    </th>

                    <th pSortableColumn="Block">
                        {{'BLOCK'| translate}}
                        <p-columnFilter type="text" field="Block" display="menu"></p-columnFilter>
                        <p-sortIcon field="Block"></p-sortIcon>
                    </th>

                    <th pSortableColumn="Village">
                        {{'VILLAGE'| translate}}
                        <p-columnFilter type="text" field="Village" display="menu"></p-columnFilter>
                        <p-sortIcon field="Village"></p-sortIcon>
                    </th>

                    <th pSortableColumn="Total_Area">
                        {{'TOTAL_AREA'| translate}}
                        <p-columnFilter type="text" field="Total_Area" display="menu"></p-columnFilter>
                        <p-sortIcon field="Total_Area"></p-sortIcon>
                    </th>

                    <th pSortableColumn="AgeOfApplication">
                        {{'AGE_OF_APPLICATION'| translate}}
                        <p-columnFilter type="text" field="AgeOfApplication" display="menu"></p-columnFilter>
                        <p-sortIcon field="AgeOfApplication"></p-sortIcon>
                    </th>

                    <th pSortableColumn="AssignedDate">{{'ASSIGNED_DATE'| translate}}
                        <p-columnFilter type="text" field="AssignedDate" display="menu"></p-columnFilter>
                        <p-sortIcon field="AssignedDate"></p-sortIcon>
                    </th>
                    <th pSortableColumn="ActionDate">{{'ACTION_DATE'| translate}}
                        <p-columnFilter type="text" field="ActionDate" display="menu"></p-columnFilter>
                        <p-sortIcon field="ActionDate"></p-sortIcon>
                    </th>

                    <th pSortableColumn="Pending_CompletedDays">
                        {{'PENDING_COMPLETED_DAYS' | translate}}
                        <p-columnFilter type="text" field="Pending_CompletedDays" display="menu"></p-columnFilter>
                        <p-sortIcon field="Pending_CompletedDays"></p-sortIcon>
                    </th>

                    <th pSortableColumn="LandDetail">
                        {{'LAND_DETAIL'| translate}}
                        <p-columnFilter type="text" field="LandDetail" display="menu"></p-columnFilter>
                        <p-sortIcon field="LandDetail"></p-sortIcon>
                    </th>

                    <th pSortableColumn="DeptRemarks">{{'REMARKS'| translate}}
                        <p-columnFilter type="text" field="DeptRemarks" display="menu"></p-columnFilter>
                        <p-sortIcon field="DeptRemarks"></p-sortIcon>
                    </th>

                    <th pSortableColumn="Status">
                        {{'STATUS'| translate}}
                        <p-columnFilter type="text" field="Status" display="menu"></p-columnFilter>
                        <p-sortIcon field="Status"></p-sortIcon>
                    </th>
                    <th pSortableColumn="Status_Ar">
                        {{'CURRENT_STATUS'| translate}}
                        <p-columnFilter type="text" field="Status_Ar" display="menu"></p-columnFilter>
                        <p-sortIcon field="Status_Ar"></p-sortIcon>
                    </th>
                    <th pSortableColumn="UserType">{{'USER_TYPE' | translate}}
                        <p-columnFilter type="text" field="UserType" display="menu"></p-columnFilter>
                        <p-sortIcon field="UserType"></p-sortIcon>
                    </th>
                    <th pSortableColumn="Coverage_Area">{{'COVERAGE_AREA' | translate}}
                        <p-columnFilter type="text" field="Coverage_Area" display="menu"></p-columnFilter>
                        <p-sortIcon field="Coverage_Area"></p-sortIcon>
                    </th>
                    <th pSortableColumn="NoOfBeneficiary">{{'NO_OF_BENEFICIARY' | translate}}
                        <p-columnFilter type="text" field="NoOfBeneficiary" display="menu"></p-columnFilter>
                        <p-sortIcon field="NoOfBeneficiary"></p-sortIcon>
                    </th>
                    <th pSortableColumn="FinYear">{{'FINANCIAL_YEAR'| translate}}
                        <p-columnFilter type="text" field="FinYear" display="menu"></p-columnFilter>
                        <p-sortIcon field="FinYear"></p-sortIcon>
                    </th>

                    <th>{{'ACTION'| translate}}</th>
                </tr>
            </ng-template>

            <ng-template pTemplate="body" let-product let-rowIndex="rowIndex">
                <tr [ngStyle]="{'color': 'black', 'background-color': rowBackgroundColor(product)}">
                    <td>
                        <button pButton pRipple pTooltip="view application" icon="pi pi-file"
                            class="p-button-rounded p-button-accent mr-1 btnSize"
                            (click)="viewFarmerApplication(product)"></button>
                    </td>
                    <!-- <td>{{ rowIndex + 1 }}</td> -->
                    <td>{{ product.appID }}</td>
                    <td>{{ product.FarmerName }}</td>
                    <td>{{ product.District }}</td>
                    <td>{{ product.Block }}</td>
                    <td>{{ product.Village }}</td>
                    <td>{{ product.Total_Area }}</td>
                    <td>{{ product.AgeOfApplication }}</td>
                    <td>{{product?.AssignedDate | date:'medium'}}</td>
                    <td>{{product.ActionDate | date:'medium'}}</td>
                    <td>{{ product.Pending_CompletedDays }}</td>
                    <td>{{ product.LandDetail }}</td>
                    <td>{{ product.DeptRemarks }}</td>
                    <td>{{ product.Status }}</td>
                    <td>{{ product.Status_Ar }}</td>
                    <td>{{product?.UserType}}</td>
                    <td>{{product?.Coverage_Area}}</td>
                    <td>{{product?.NoOfBeneficiary}}</td>
                    <td>{{product.FinYear}}</td>

                    <td *ngIf="product?.AppEditableStatus == '1'">
                        <button (click)="selectTankRowData(product)" icon="pi pi-pencil" pButton pRipple type="button"
                            class="p-button-rounded p-button-text"></button>
                    </td>
                    <td *ngIf="product?.AppEditableStatus == '2'">
                        <button (click)="selectTankRowData(product)" icon="pi pi-fw pi-plus" pButton pRipple
                            type="button" class="p-button-rounded p-button-text"></button>
                    </td>
                </tr>
            </ng-template>
            <ng-template pTemplate="summary">
                <div class="flex  justify-content-between flex-column ">
                    <p>{{'IN_TOTAL_THERE_ARE'| translate}} {{tankData ? tankData.length : 0 }}
                        {{'APPLICATION_ADDED'| translate}}.
                    </p>
                    <div class="flex  justify-content-between flex-column ">
                        <div class="flex">
                            <div
                                style="background-color:#ff8080 ; width: 20px; height: 20px;border-radius: 5px;margin-bottom: 2px;margin-right: 4px;">
                            </div>{{'PENDING_MORE_THAN_TWO_DAYS'| translate}}
                        </div>
                        <div class="flex">
                            <div
                                style="background-color:#ffc966 ; width: 20px; height: 20px;border-radius: 5px;margin-bottom: 2px;margin-right: 4px;">
                            </div>{{'PENDING_BY_ONE_DAY'| translate}}
                        </div>
                        <div class="flex">
                            <div
                                style="background-color:#99e699 ; width: 20px; height: 20px;border-radius: 5px;margin-bottom: 2px;margin-right: 4px;">
                            </div>{{'APROVED_ON_TIME'| translate}}
                        </div>
                        <div class="flex">
                            <div
                                style="background-color:#ffb3b3 ; width: 20px; height: 20px;border-radius: 5px;margin-bottom: 2px;margin-right: 4px;">
                            </div>{{'DELAYED_APPROVED'| translate}}
                        </div>
                    </div>
                </div>
            </ng-template>
        </p-table>
    </div>
    <!-- </p-card> -->
</div>

<p-dialog [(visible)]="displayTankDialog" [modal]="true" [style]="{ width: '100%', height: '100%' }" [maximizable]="true"
    [draggable]="false" [resizable]="false" (onHide)="onCloseDialog()" [baseZIndex]="-100">

    <div class="p-fluid p-formgrid grid justify-content-center">
        <div class="field col-4 md:col-4">
            <label>{{'APP_ID'| translate}}: <label [style]="{color: 'rgb(168, 32, 32)'}">{{  selectedApplication?.appID }}</label></label>
        </div>
        <div class="field col-4 md:col-4">
            <label>{{'SCHEME_NAME'| translate}}: <label [style]="{color: 'rgb(168, 32, 32)'}">{{ selectedApplication?.Scheme_Code }}</label></label>
        </div>
        <div class="field md:col-4 col-12">
            <label>{{'NO_OF_BENEFICIARY'| translate}}: <label [style]="{color: 'rgb(168, 32, 32)', fontSize:'1rem'}">{{ selectedApplication?.NoOfBeneficiary}}</label></label>
        </div>
    </div>


    <!-- JE SURVEY STAGE-1 Content Start -->
    <div *ngIf="surveyStage1JE?.IsExist == 1 && surveyStage1JE?.ActionType == 'SurveyStg1_JE'" class="card jeSurvey-stage1-data" style="margin-bottom: 5px;">
        <div class="p-fluid p-formgrid grid justify-content-center mb-2 bold sub-heading">
            {{'SURVEY_STAGE1_JE'| translate}}
        </div>
        <div class="p-fluid p-formgrid grid">
            <div class="field col-12 md:col-3">
                <label>{{'ACTUAL_SUBSIDY_STAGE1'| translate}}</label>
                <div class="grid-item">
                    <p>{{ surveyStage1JE?.ActualSubsidy_Stage1 }}</p>
                </div>
            </div>

            <div class="field col-12 md:col-3">
                <label>{{'CENTER_SHARE_AMOUNT'| translate}}</label>
                <div class="grid-item">
                    <p>{{ surveyStage1JE?.CenterShare_Amount }}</p>
                </div>
            </div>

            <div class="field col-12 md:col-3">
                <label>{{'STATE_SHARE_AMOUNT'| translate}}</label>
                <div class="grid-item">
                    <p>{{ surveyStage1JE?.StateShare_Amount }}</p>
                </div>
            </div>

            <div class="field col-12 md:col-3">
                <label>{{'ABY_AMOUNT'| translate}}</label>
                <div class="grid-item">
                    <p>{{ surveyStage1JE?.ABY }}</p>
                </div>
            </div>
            
            <div class="field col-12 md:col-3">
                <label>{{'TOP_UP_AMOUNT'| translate}}</label>
                <div class="grid-item">
                    <p>{{ surveyStage1JE?.Topup }}</p>
                </div>
            </div>            
            
            <div class="field col-12 md:col-3">
                <label>{{'COVERAGE_AREA'| translate}}</label>
                <div class="grid-item">
                    <p>{{ surveyStage1JE?.Coverage_Area }}</p>
                </div>
            </div>

            <div class="field col-12 md:col-3">
                <label>{{'NO_OF_BENEFICIARY'| translate}}</label>
                <div class="grid-item">
                    <p>{{ surveyStage1JE?.NoOfBeneficiary }}</p>
                </div>
            </div>

            <div class="field col-12 md:col-3">
                <label>{{'VOLUME_EARTH_WORK'| translate}}</label>
                <div class="grid-item">
                    <p>{{ surveyStage1JE?.VolumeEarthWork }}</p>
                </div>
            </div>
            
            <div class="field col-12 md:col-3">
                <label>{{'BOTTOM_BREADTH'| translate}}</label>
                <div class="grid-item">
                    <p>{{ surveyStage1JE?.bottomBreadth }}</p>
                </div>
            </div>

            <div class="field col-12 md:col-3">
                <label>{{'BOTTOM_LENGTH'| translate}}</label>
                <div class="grid-item">
                    <p>{{ surveyStage1JE?.bottomLength }}</p>
                </div>
            </div>

            <div class="field col-12 md:col-3">
                <label>{{'BOTTOM_SIZE'| translate}}</label>
                <div class="grid-item">
                    <p>{{ surveyStage1JE?.bottomSize }}</p>
                </div>
            </div>

            <div class="field col-12 md:col-3">
                <label>{{'DEPTH'| translate}}</label>
                <div class="grid-item">
                    <p>{{ surveyStage1JE?.depth }}</p>
                </div>
            </div>

            <div class="field col-12 md:col-3">
                <label>{{'ESTIMATE_COST'| translate}}</label>
                <div class="grid-item">
                    <p>{{ surveyStage1JE?.estimateCost }}</p>
                </div>
            </div>

            <div class="field col-12 md:col-3">
                <label>{{'TANK_LAT'| translate}}</label>
                <div class="grid-item">
                    <p>{{ surveyStage1JE?.tankLat }}</p>
                </div>
            </div>

            <div class="field col-12 md:col-3">
                <label>{{'TANK_LONG'| translate}}</label>
                <div class="grid-item">
                    <p>{{ surveyStage1JE?.tankLng }}</p>
                </div>
            </div>

            <div class="field col-12 md:col-3">
                <label>{{'TOP_SIZE'| translate}}</label>
                <div class="grid-item">
                    <p>{{ surveyStage1JE?.topSize }}</p>
                </div>
            </div>

            <div class="field col-12 md:col-3">
                <label>{{'TOP_BREADTH'| translate}}</label>
                <div class="grid-item">
                    <p>{{ surveyStage1JE?.topBreadth }}</p>
                </div>
            </div>

            <div class="field col-12 md:col-3">
                <label>{{'TOP_LENGTH'| translate}}</label>
                <div class="grid-item">
                    <p>{{ surveyStage1JE?.topLength }}</p>
                </div>
            </div>

            <div class="field col-12 md:col-3">
                <label>{{'TOP_SIZE'| translate}}</label>
                <div class="grid-item">
                    <p>{{ surveyStage1JE?.topSize }}</p>
                </div>
            </div>

            <div class="field col-12 md:col-3">
                <label>{{'ESTIMATE_COPY'| translate}}</label>
                <div class="grid-item">
                    <p *ngIf="surveyStage1JE?.estimateCopy">
                        <a style="cursor: pointer" [href]="surveyStage1JE?.estimateCopy"
                          target="_blank">{{'VIEW_COPY' | translate}}</a>
                      </p>
                </div>
            </div>
        </div>
    </div>
    <!-- JE SURVEY STAGE-1 Content End -->

    <!-- XEN SURVEY STAGE-1 Content Start -->
    <div *ngIf="surveyStage1XEN?.IsExist == 1 && surveyStage1XEN?.ActionType == 'SurveyStg1_XEN'" class="card xenSurvey-stage1-data" style="margin-bottom: 5px;">
        <div class="p-fluid p-formgrid grid justify-content-center mb-2 bold sub-heading">
            {{'SURVEY_STAGE1_XEN'| translate}}
        </div>
        <div class="p-fluid p-formgrid grid">
            <div class="field col-12 md:col-3">
                <label>{{'ACTUAL_SUBSIDY_STAGE1'| translate}}</label>
                <div class="grid-item">
                    <p>{{ surveyStage1XEN?.ActualSubsidy_Stage1 }}</p>
                </div>
            </div>

            <div class="field col-12 md:col-3">
                <label>{{'CENTER_SHARE_AMOUNT'| translate}}</label>
                <div class="grid-item">
                    <p>{{ surveyStage1XEN?.CenterShare_Amount }}</p>
                </div>
            </div>

            <div class="field col-12 md:col-3">
                <label>{{'STATE_SHARE_AMOUNT'| translate}}</label>
                <div class="grid-item">
                    <p>{{ surveyStage1XEN?.StateShare_Amount }}</p>
                </div>
            </div>

            <div class="field col-12 md:col-3">
                <label>{{'ABY_AMOUNT'| translate}}</label>
                <div class="grid-item">
                    <p>{{ surveyStage1XEN?.ABY }}</p>
                </div>
            </div>
            
            <div class="field col-12 md:col-3">
                <label>{{'TOP_UP_AMOUNT'| translate}}</label>
                <div class="grid-item">
                    <p>{{ surveyStage1XEN?.Topup }}</p>
                </div>
            </div>

            <div class="field col-12 md:col-3">
                <label>{{'COVERAGE_AREA'| translate}}</label>
                <div class="grid-item">
                    <p>{{ surveyStage1XEN?.Coverage_Area }}</p>
                </div>
            </div>

            <div class="field col-12 md:col-3">
                <label>{{'NO_OF_BENEFICIARY'| translate}}</label>
                <div class="grid-item">
                    <p>{{ surveyStage1XEN?.NoOfBeneficiary }}</p>
                </div>
            </div>

            <div class="field col-12 md:col-3">
                <label>{{'VOLUME_EARTH_WORK'| translate}}</label>
                <div class="grid-item">
                    <p>{{ surveyStage1XEN?.VolumeEarthWork }}</p>
                </div>
            </div>
            
            <div class="field col-12 md:col-3">
                <label>{{'BOTTOM_BREADTH'| translate}}</label>
                <div class="grid-item">
                    <p>{{ surveyStage1XEN?.bottomBreadth }}</p>
                </div>
            </div>

            <div class="field col-12 md:col-3">
                <label>{{'BOTTOM_LENGTH'| translate}}</label>
                <div class="grid-item">
                    <p>{{ surveyStage1XEN?.bottomLength }}</p>
                </div>
            </div>

            <div class="field col-12 md:col-3">
                <label>{{'BOTTOM_SIZE'| translate}}</label>
                <div class="grid-item">
                    <p>{{ surveyStage1XEN?.bottomSize }}</p>
                </div>
            </div>

            <div class="field col-12 md:col-3">
                <label>{{'DEPTH'| translate}}</label>
                <div class="grid-item">
                    <p>{{ surveyStage1XEN?.depth }}</p>
                </div>
            </div>

            <div class="field col-12 md:col-3">
                <label>{{'ESTIMATE_COST'| translate}}</label>
                <div class="grid-item">
                    <p>{{ surveyStage1XEN?.estimateCost }}</p>
                </div>
            </div>

            <div class="field col-12 md:col-3">
                <label>{{'TANK_LAT'| translate}}</label>
                <div class="grid-item">
                    <p>{{ surveyStage1XEN?.tankLat }}</p>
                </div>
            </div>

            <div class="field col-12 md:col-3">
                <label>{{'TANK_LONG'| translate}}</label>
                <div class="grid-item">
                    <p>{{ surveyStage1XEN?.tankLng }}</p>
                </div>
            </div>

            <div class="field col-12 md:col-3">
                <label>{{'TOP_SIZE'| translate}}</label>
                <div class="grid-item">
                    <p>{{ surveyStage1XEN?.topSize }}</p>
                </div>
            </div>

            <div class="field col-12 md:col-3">
                <label>{{'TOP_BREADTH'| translate}}</label>
                <div class="grid-item">
                    <p>{{ surveyStage1XEN?.topBreadth }}</p>
                </div>
            </div>

            <div class="field col-12 md:col-3">
                <label>{{'TOP_LENGTH'| translate}}</label>
                <div class="grid-item">
                    <p>{{ surveyStage1XEN?.topLength }}</p>
                </div>
            </div>

            <div class="field col-12 md:col-3">
                <label>{{'TOP_SIZE'| translate}}</label>
                <div class="grid-item">
                    <p>{{ surveyStage1XEN?.topSize }}</p>
                </div>
            </div>

            <div class="field col-12 md:col-3">
                <label>{{'ESTIMATE_COPY'| translate}}</label>
                <div class="grid-item">
                    <p *ngIf="surveyStage1XEN?.estimateCopy">
                        <a style="cursor: pointer" [href]="surveyStage1XEN?.estimateCopy"
                          target="_blank">{{'VIEW_COPY' | translate}}</a>
                      </p>
                </div>
            </div>
        </div>
    </div>
    <!-- XEN SURVEY STAGE-1 Content End -->


    <!-- JE SURVEY STAGE-2 Content Start -->
    <div *ngIf="surveyStage2JE?.IsExist == 1 && surveyStage2JE?.ActionType == 'SurveyStg2_JE'" class="card jeSurvey-stage2-data" style="margin-bottom: 5px;">
        <div class="p-fluid p-formgrid grid justify-content-center mb-2 bold sub-heading">
            {{'SURVEY_STAGE2_JE'| translate}}
        </div>
        <div class="p-fluid p-formgrid grid">
            <div class="field col-12 md:col-3">
                <label>{{'ACTUAL_SUBSIDY_STAGE2'| translate}}</label>
                <div class="grid-item">
                    <p>{{ surveyStage2JE?.ActualSubsidy_Stage2 }}</p>
                </div>
            </div>

            <div class="field col-12 md:col-3">
                <label>{{'ASSISTANCE_PAID_AT_STAGE2'| translate}}</label>
                <div class="grid-item">
                    <p>{{ surveyStage2JE?.AssistancePaidAtStage1 }}</p>
                </div>
            </div>

            <div class="field col-12 md:col-3">
                <label>{{'CENTER_SHARE_AMOUNT'| translate}}</label>
                <div class="grid-item">
                    <p>{{ surveyStage2JE?.CenterShare_Amount }}</p>
                </div>
            </div>

            <div class="field col-12 md:col-3">
                <label>{{'STATE_SHARE_AMOUNT'| translate}}</label>
                <div class="grid-item">
                    <p>{{ surveyStage2JE?.StateShare_Amount }}</p>
                </div>
            </div>

            <div class="field col-12 md:col-3">
                <label>{{'ABY_AMOUNT'| translate}}</label>
                <div class="grid-item">
                    <p>{{ surveyStage2JE?.ABY }}</p>
                </div>
            </div>
            
            <div class="field col-12 md:col-3">
                <label>{{'TOP_UP_AMOUNT'| translate}}</label>
                <div class="grid-item">
                    <p>{{ surveyStage2JE?.Topup }}</p>
                </div>
            </div>

            <div class="field col-12 md:col-3">
                <label>{{'COVERAGE_AREA'| translate}}</label>
                <div class="grid-item">
                    <p>{{ surveyStage2JE?.Coverage_Area }}</p>
                </div>
            </div>

            <div class="field col-12 md:col-3">
                <label>{{'NO_OF_BENEFICIARY'| translate}}</label>
                <div class="grid-item">
                    <p>{{ surveyStage2JE?.NoOfBeneficiary }}</p>
                </div>
            </div>
            
            <div class="field col-12 md:col-3">
                <label>{{'SURVEY_TYPE'| translate}}</label>
                <div class="grid-item">
                    <p>{{ surveyStage2JE?.SurveyType }}</p>
                </div>
            </div>

            <div class="field col-12 md:col-3">
                <label>{{'TOTAL_ESTIMATED_COST'| translate}}</label>
                <div class="grid-item">
                    <p>{{ surveyStage2JE?.TotalEstimatedCost }}</p>
                </div>
            </div>

            <div class="field col-12 md:col-3">
                <label>{{'TOTAL_ESTIMATED_SUBSIDY'| translate}}</label>
                <div class="grid-item">
                    <p>{{ surveyStage2JE?.TotalEstimatedSubsidy }}</p>
                </div>
            </div>

            <div class="field col-12 md:col-3">
                <label>{{'TYPE_OF_POND'| translate}}</label>
                <div class="grid-item">
                    <p>{{ surveyStage2JE?.TypeOfPond }}</p>
                </div>
            </div>

            <div class="field col-12 md:col-3">
                <label>{{'UPDATED_AT'| translate}}</label>
                <div class="grid-item">
                    <p>{{ surveyStage2JE?.Updated_at | date }}</p>
                </div>
            </div>

            <div class="field col-12 md:col-3">
                <label>{{'BOTTOM_BREADTH'| translate}}</label>
                <div class="grid-item">
                    <p>{{ surveyStage2JE?.bottomBreadth }}</p>
                </div>
            </div>

            <div class="field col-12 md:col-3">
                <label>{{'BOTTOM_LENGTH'| translate}}</label>
                <div class="grid-item">
                    <p>{{ surveyStage2JE?.bottomLength }}</p>
                </div>
            </div>

            <div class="field col-12 md:col-3">
                <label>{{'USER_ID'| translate}}</label>
                <div class="grid-item">
                    <p>{{ surveyStage2JE?.UserID }}</p>
                </div>
            </div>

            <div class="field col-12 md:col-3">
                <label>{{'BOTTOM_SIZE'| translate}}</label>
                <div class="grid-item">
                    <p>{{ surveyStage2JE?.bottomSize }}</p>
                </div>
            </div>

            <div class="field col-12 md:col-3">
                <label>{{'CREATED_AT'| translate}}</label>
                <div class="grid-item">
                    <p>{{ surveyStage2JE?.created_at | date }}</p>
                </div>
            </div>

            <div class="field col-12 md:col-3">
                <label>{{'DEPTH'| translate}}</label>
                <div class="grid-item">
                    <p>{{ surveyStage2JE?.depth }}</p>
                </div>
            </div>

            <div class="field col-12 md:col-3">
                <label>{{'TANK_LAT'| translate}}</label>
                <div class="grid-item">
                    <p>{{ surveyStage2JE?.tankLat }}</p>
                </div>
            </div>

            <div class="field col-12 md:col-3">
                <label>{{'TANK_LONG'| translate}}</label>
                <div class="grid-item">
                    <p>{{ surveyStage2JE?.tankLng }}</p>
                </div>
            </div>

            <div class="field col-12 md:col-3">
                <label>{{'TOP_BREADTH'| translate}}</label>
                <div class="grid-item">
                    <p>{{ surveyStage2JE?.topBreadth }}</p>
                </div>
            </div>

            <div class="field col-12 md:col-3">
                <label>{{'TOP_LENGTH'| translate}}</label>
                <div class="grid-item">
                    <p>{{ surveyStage2JE?.topLength }}</p>
                </div>
            </div>

            <div class="field col-12 md:col-3">
                <label>{{'TOP_SIZE'| translate}}</label>
                <div class="grid-item">
                    <p>{{ surveyStage2JE?.topSize }}</p>
                </div>
            </div>
            
            <div class="field col-12 md:col-3">
                <label>{{'ESTIMATE_COPY'| translate}}</label>
                <div class="grid-item">
                    <p *ngIf="surveyStage2JE?.MeasurementCopy">
                        <a style="cursor: pointer" [href]="surveyStage2JE?.MeasurementCopy"
                          target="_blank">{{'VIEW_COPY' | translate}}</a>
                      </p>
                </div>
            </div>
        </div>
    </div>
    <!-- JE SURVEY STAGE-2 Content End -->


    <!-- XEN SURVEY STAGE-2 Content Start -->
    <div *ngIf="surveyStage2XEN?.IsExist == 1 && surveyStage2XEN?.ActionType == 'SurveyStg2_XEN'" class="card xenSurvey-stage2-data" style="margin-bottom: 5px;">
        <div class="p-fluid p-formgrid grid justify-content-center mb-2 bold sub-heading">
            {{'SURVEY_STAGE2_XEN'| translate}}
        </div>
        <div class="p-fluid p-formgrid grid">
            <div class="field col-12 md:col-3">
                <label>{{'ACTUAL_SUBSIDY_STAGE2'| translate}}</label>
                <div class="grid-item">
                    <p>{{ surveyStage2XEN?.ActualSubsidy_Stage2 }}</p>
                </div>
            </div>

            <div class="field col-12 md:col-3">
                <label>{{'ASSISTANCE_PAID_AT_STAGE2'| translate}}</label>
                <div class="grid-item">
                    <p>{{ surveyStage2XEN?.AssistancePaidAtStage1 }}</p>
                </div>
            </div>

            <div class="field col-12 md:col-3">
                <label>{{'CENTER_SHARE_AMOUNT'| translate}}</label>
                <div class="grid-item">
                    <p>{{ surveyStage2XEN?.CenterShare_Amount }}</p>
                </div>
            </div>

            <div class="field col-12 md:col-3">
                <label>{{'STATE_SHARE_AMOUNT'| translate}}</label>
                <div class="grid-item">
                    <p>{{ surveyStage2XEN?.StateShare_Amount }}</p>
                </div>
            </div>

            <div class="field col-12 md:col-3">
                <label>{{'ABY_AMOUNT'| translate}}</label>
                <div class="grid-item">
                    <p>{{ surveyStage2XEN?.ABY }}</p>
                </div>
            </div>
            
            <div class="field col-12 md:col-3">
                <label>{{'TOP_UP_AMOUNT'| translate}}</label>
                <div class="grid-item">
                    <p>{{ surveyStage2XEN?.Topup }}</p>
                </div>
            </div>

            <div class="field col-12 md:col-3">
                <label>{{'COVERAGE_AREA'| translate}}</label>
                <div class="grid-item">
                    <p>{{ surveyStage2XEN?.Coverage_Area }}</p>
                </div>
            </div>

            <div class="field col-12 md:col-3">
                <label>{{'NO_OF_BENEFICIARY'| translate}}</label>
                <div class="grid-item">
                    <p>{{ surveyStage2XEN?.NoOfBeneficiary }}</p>
                </div>
            </div>
            
            <div class="field col-12 md:col-3">
                <label>{{'SURVEY_TYPE'| translate}}</label>
                <div class="grid-item">
                    <p>{{ surveyStage2XEN?.SurveyType }}</p>
                </div>
            </div>

            <div class="field col-12 md:col-3">
                <label>{{'TOTAL_ESTIMATED_COST'| translate}}</label>
                <div class="grid-item">
                    <p>{{ surveyStage2XEN?.TotalEstimatedCost }}</p>
                </div>
            </div>

            <div class="field col-12 md:col-3">
                <label>{{'TOTAL_ESTIMATED_SUBSIDY'| translate}}</label>
                <div class="grid-item">
                    <p>{{ surveyStage2XEN?.TotalEstimatedSubsidy }}</p>
                </div>
            </div>

            <div class="field col-12 md:col-3">
                <label>{{'TYPE_OF_POND'| translate}}</label>
                <div class="grid-item">
                    <p>{{ surveyStage2XEN?.TypeOfPond }}</p>
                </div>
            </div>

            <div class="field col-12 md:col-3">
                <label>{{'UPDATED_AT'| translate}}</label>
                <div class="grid-item">
                    <p>{{ surveyStage2XEN?.Updated_at | date }}</p>
                </div>
            </div>

            <div class="field col-12 md:col-3">
                <label>{{'BOTTOM_BREADTH'| translate}}</label>
                <div class="grid-item">
                    <p>{{ surveyStage2XEN?.bottomBreadth }}</p>
                </div>
            </div>

            <div class="field col-12 md:col-3">
                <label>{{'BOTTOM_LENGTH'| translate}}</label>
                <div class="grid-item">
                    <p>{{ surveyStage2XEN?.bottomLength }}</p>
                </div>
            </div>

            <div class="field col-12 md:col-3">
                <label>{{'USER_ID'| translate}}</label>
                <div class="grid-item">
                    <p>{{ surveyStage2XEN?.UserID }}</p>
                </div>
            </div>

            <div class="field col-12 md:col-3">
                <label>{{'BOTTOM_SIZE'| translate}}</label>
                <div class="grid-item">
                    <p>{{ surveyStage2XEN?.bottomSize }}</p>
                </div>
            </div>

            <div class="field col-12 md:col-3">
                <label>{{'CREATED_AT'| translate}}</label>
                <div class="grid-item">
                    <p>{{ surveyStage2XEN?.created_at | date }}</p>
                </div>
            </div>

            <div class="field col-12 md:col-3">
                <label>{{'DEPTH'| translate}}</label>
                <div class="grid-item">
                    <p>{{ surveyStage2XEN?.depth }}</p>
                </div>
            </div>

            <div class="field col-12 md:col-3">
                <label>{{'TANK_LAT'| translate}}</label>
                <div class="grid-item">
                    <p>{{ surveyStage2XEN?.tankLat }}</p>
                </div>
            </div>

            <div class="field col-12 md:col-3">
                <label>{{'TANK_LONG'| translate}}</label>
                <div class="grid-item">
                    <p>{{ surveyStage2XEN?.tankLng }}</p>
                </div>
            </div>

            <div class="field col-12 md:col-3">
                <label>{{'TOP_BREADTH'| translate}}</label>
                <div class="grid-item">
                    <p>{{ surveyStage2XEN?.topBreadth }}</p>
                </div>
            </div>

            <div class="field col-12 md:col-3">
                <label>{{'TOP_LENGTH'| translate}}</label>
                <div class="grid-item">
                    <p>{{ surveyStage2XEN?.topLength }}</p>
                </div>
            </div>

            <div class="field col-12 md:col-3">
                <label>{{'TOP_SIZE'| translate}}</label>
                <div class="grid-item">
                    <p>{{ surveyStage2XEN?.topSize }}</p>
                </div>
            </div>
            
            <div class="field col-12 md:col-3">
                <label>{{'ESTIMATE_COPY'| translate}}</label>
                <div class="grid-item">
                    <p *ngIf="surveyStage2XEN?.MeasurementCopy">
                        <a style="cursor: pointer" [href]="surveyStage2XEN?.MeasurementCopy"
                          target="_blank">{{'VIEW_COPY' | translate}}</a>
                      </p>
                </div>
            </div>
        </div>
    </div>
    <!-- XEN SURVEY STAGE-2 Content End -->

    <!--  CAL STAGE-1 JE Content Start -->
    <div *ngIf="calStage1JE?.IsExist == 1 && calStage1JE?.ActionType == 'CalcStg1_Admin'" class="card calStage1-admin-data" style="margin-bottom: 5px;">
        <div class="p-fluid p-formgrid grid justify-content-center mb-2 bold sub-heading">
            {{'CAL_STAGE1_JE'| translate}}
        </div>
        <div class="p-fluid p-formgrid grid">
            <div class="field col-12 md:col-3">
                <label>{{'ACTUAL_SUBSIDY_STAGE1'| translate}}</label>
                <div class="grid-item">
                    <p>{{ calStage1JE?.ActualSubsidy_Stage1 }}</p>
                </div>
            </div>

            <div class="field col-12 md:col-3">
                <label>{{'CENTER_SHARE_AMOUNT'| translate}}</label>
                <div class="grid-item">
                    <p>{{ calStage1JE?.CenterShare_Amount }}</p>
                </div>
            </div>

            <div class="field col-12 md:col-3">
                <label>{{'STATE_SHARE_AMOUNT'| translate}}</label>
                <div class="grid-item">
                    <p>{{ calStage1JE?.StateShare_Amount }}</p>
                </div>
            </div>

            <div class="field col-12 md:col-3">
                <label>{{'ABY_AMOUNT'| translate}}</label>
                <div class="grid-item">
                    <p>{{ calStage1JE?.ABY }}</p>
                </div>
            </div>
            
            <div class="field col-12 md:col-3">
                <label>{{'TOP_UP_AMOUNT'| translate}}</label>
                <div class="grid-item">
                    <p>{{ calStage1JE?.Topup }}</p>
                </div>
            </div>

            <div class="field col-12 md:col-3">
                <label>{{'COVERAGE_AREA'| translate}}</label>
                <div class="grid-item">
                    <p>{{ calStage1JE?.Coverage_Area }}</p>
                </div>
            </div>

            <div class="field col-12 md:col-3">
                <label>{{'NO_OF_BENEFICIARY'| translate}}</label>
                <div class="grid-item">
                    <p>{{ calStage1JE?.NoOfBeneficiary }}</p>
                </div>
            </div>

            <div class="field col-12 md:col-3">
                <label>{{'VOLUME_EARTH_WORK'| translate}}</label>
                <div class="grid-item">
                    <p>{{ calStage1JE?.VolumeEarthWork }}</p>
                </div>
            </div>
            
            <div class="field col-12 md:col-3">
                <label>{{'BOTTOM_BREADTH'| translate}}</label>
                <div class="grid-item">
                    <p>{{ calStage1JE?.bottomBreadth }}</p>
                </div>
            </div>

            <div class="field col-12 md:col-3">
                <label>{{'BOTTOM_LENGTH'| translate}}</label>
                <div class="grid-item">
                    <p>{{ calStage1JE?.bottomLength }}</p>
                </div>
            </div>

            <div class="field col-12 md:col-3">
                <label>{{'BOTTOM_SIZE'| translate}}</label>
                <div class="grid-item">
                    <p>{{ calStage1JE?.bottomSize }}</p>
                </div>
            </div>

            <div class="field col-12 md:col-3">
                <label>{{'DEPTH'| translate}}</label>
                <div class="grid-item">
                    <p>{{ calStage1JE?.depth }}</p>
                </div>
            </div>

            <div class="field col-12 md:col-3">
                <label>{{'USER_ID'| translate}}</label>
                <div class="grid-item">
                    <p>{{ calStage1JE?.UserID }}</p>
                </div>
            </div>
            
            <div class="field col-12 md:col-3">
                <label>{{'ESTIMATE_COST'| translate}}</label>
                <div class="grid-item">
                    <p>{{ calStage1JE?.estimateCost }}</p>
                </div>
            </div>
            
            <div class="field col-12 md:col-3">
                <label>{{'TANK_LAT'| translate}}</label>
                <div class="grid-item">
                    <p>{{ calStage1JE?.tankLat }}</p>
                </div>
            </div>

            <div class="field col-12 md:col-3">
                <label>{{'TANK_LONG'| translate}}</label>
                <div class="grid-item">
                    <p>{{ calStage1JE?.tankLng }}</p>
                </div>
            </div>

            <div class="field col-12 md:col-3">
                <label>{{'TOP_BREADTH'| translate}}</label>
                <div class="grid-item">
                    <p>{{ calStage1JE?.topBreadth }}</p>
                </div>
            </div>

            <div class="field col-12 md:col-3">
                <label>{{'TOP_LENGTH'| translate}}</label>
                <div class="grid-item">
                    <p>{{ calStage1JE?.topLength }}</p>
                </div>
            </div>

            <div class="field col-12 md:col-3">
                <label>{{'TOP_SIZE'| translate}}</label>
                <div class="grid-item">
                    <p>{{ calStage1JE?.topSize }}</p>
                </div>
            </div>

            <div class="field col-12 md:col-3">
                <label>{{'ESTIMATE_COPY'| translate}}</label>
                <div class="grid-item">
                    <p *ngIf="calStage1JE?.MeasurementCopy">
                        <a style="cursor: pointer" [href]="calStage1JE?.MeasurementCopy"
                          target="_blank">{{'VIEW_COPY' | translate}}</a>
                      </p>
                </div>
            </div>
        </div>
    </div>
    <!-- CAL STAGE-1 JE Content End -->


    <!--  CAL STAGE-1 DD Content Start -->
    <div *ngIf="calStage1DD?.IsExist == 1 && calStage1DD?.ActionType == 'CalcStg1_Admin'" class="card calStage1-admin-data" style="margin-bottom: 5px;">
        <div class="p-fluid p-formgrid grid justify-content-center mb-2 bold sub-heading">
            {{'CAL_STAGE1_DD'| translate}}
        </div>
        <div class="p-fluid p-formgrid grid">
            <div class="field col-12 md:col-3">
                <label>{{'ACTUAL_SUBSIDY_STAGE1'| translate}}</label>
                <div class="grid-item">
                    <p>{{ calStage1DD?.ActualSubsidy_Stage1 }}</p>
                </div>
            </div>

            <div class="field col-12 md:col-3">
                <label>{{'CENTER_SHARE_AMOUNT'| translate}}</label>
                <div class="grid-item">
                    <p>{{ calStage1DD?.CenterShare_Amount }}</p>
                </div>
            </div>

            <div class="field col-12 md:col-3">
                <label>{{'STATE_SHARE_AMOUNT'| translate}}</label>
                <div class="grid-item">
                    <p>{{ calStage1DD?.StateShare_Amount }}</p>
                </div>
            </div>

            <div class="field col-12 md:col-3">
                <label>{{'ABY_AMOUNT'| translate}}</label>
                <div class="grid-item">
                    <p>{{ calStage1DD?.ABY }}</p>
                </div>
            </div>
            
            <div class="field col-12 md:col-3">
                <label>{{'TOP_UP_AMOUNT'| translate}}</label>
                <div class="grid-item">
                    <p>{{ calStage1DD?.Topup }}</p>
                </div>
            </div>

            <div class="field col-12 md:col-3">
                <label>{{'COVERAGE_AREA'| translate}}</label>
                <div class="grid-item">
                    <p>{{ calStage1DD?.Coverage_Area }}</p>
                </div>
            </div>

            <div class="field col-12 md:col-3">
                <label>{{'NO_OF_BENEFICIARY'| translate}}</label>
                <div class="grid-item">
                    <p>{{ calStage1DD?.NoOfBeneficiary }}</p>
                </div>
            </div>

            <div class="field col-12 md:col-3">
                <label>{{'VOLUME_EARTH_WORK'| translate}}</label>
                <div class="grid-item">
                    <p>{{ calStage1DD?.VolumeEarthWork }}</p>
                </div>
            </div>
            
            <div class="field col-12 md:col-3">
                <label>{{'BOTTOM_BREADTH'| translate}}</label>
                <div class="grid-item">
                    <p>{{ calStage1DD?.bottomBreadth }}</p>
                </div>
            </div>

            <div class="field col-12 md:col-3">
                <label>{{'BOTTOM_LENGTH'| translate}}</label>
                <div class="grid-item">
                    <p>{{ calStage1DD?.bottomLength }}</p>
                </div>
            </div>

            <div class="field col-12 md:col-3">
                <label>{{'BOTTOM_SIZE'| translate}}</label>
                <div class="grid-item">
                    <p>{{ calStage1DD?.bottomSize }}</p>
                </div>
            </div>

            <div class="field col-12 md:col-3">
                <label>{{'DEPTH'| translate}}</label>
                <div class="grid-item">
                    <p>{{ calStage1DD?.depth }}</p>
                </div>
            </div>

            <div class="field col-12 md:col-3">
                <label>{{'USER_ID'| translate}}</label>
                <div class="grid-item">
                    <p>{{ calStage1DD?.UserID }}</p>
                </div>
            </div>
            
            <div class="field col-12 md:col-3">
                <label>{{'ESTIMATE_COST'| translate}}</label>
                <div class="grid-item">
                    <p>{{ calStage1DD?.estimateCost }}</p>
                </div>
            </div>
            
            <div class="field col-12 md:col-3">
                <label>{{'TANK_LAT'| translate}}</label>
                <div class="grid-item">
                    <p>{{ calStage1DD?.tankLat }}</p>
                </div>
            </div>

            <div class="field col-12 md:col-3">
                <label>{{'TANK_LONG'| translate}}</label>
                <div class="grid-item">
                    <p>{{ calStage1DD?.tankLng }}</p>
                </div>
            </div>

            <div class="field col-12 md:col-3">
                <label>{{'TOP_BREADTH'| translate}}</label>
                <div class="grid-item">
                    <p>{{ calStage1DD?.topBreadth }}</p>
                </div>
            </div>

            <div class="field col-12 md:col-3">
                <label>{{'TOP_LENGTH'| translate}}</label>
                <div class="grid-item">
                    <p>{{ calStage1DD?.topLength }}</p>
                </div>
            </div>

            <div class="field col-12 md:col-3">
                <label>{{'TOP_SIZE'| translate}}</label>
                <div class="grid-item">
                    <p>{{ calStage1DD?.topSize }}</p>
                </div>
            </div>

            <div class="field col-12 md:col-3">
                <label>{{'ESTIMATE_COPY'| translate}}</label>
                <div class="grid-item">
                    <p *ngIf="calStage1DD?.MeasurementCopy">
                        <a style="cursor: pointer" [href]="calStage1DD?.MeasurementCopy"
                          target="_blank">{{'VIEW_COPY' | translate}}</a>
                      </p>
                </div>
            </div>
        </div>
    </div>
    <!-- CAL STAGE-1 DD Content End -->

    <!--  CAL STAGE-1 DA Content Start -->
    <div *ngIf="calStage1DA?.IsExist == 1 && calStage1DA?.ActionType == 'CalcStg1_Admin'" class="card calStage1-admin-data" style="margin-bottom: 5px;">
        <div class="p-fluid p-formgrid grid justify-content-center mb-2 bold sub-heading">
            {{'CAL_STAGE1_DA'| translate}}
        </div>
        <div class="p-fluid p-formgrid grid">
            <div class="field col-12 md:col-3">
                <label>{{'ACTUAL_SUBSIDY_STAGE1'| translate}}</label>
                <div class="grid-item">
                    <p>{{ calStage1DA?.ActualSubsidy_Stage1 }}</p>
                </div>
            </div>

            <div class="field col-12 md:col-3">
                <label>{{'CENTER_SHARE_AMOUNT'| translate}}</label>
                <div class="grid-item">
                    <p>{{ calStage1DA?.CenterShare_Amount }}</p>
                </div>
            </div>

            <div class="field col-12 md:col-3">
                <label>{{'STATE_SHARE_AMOUNT'| translate}}</label>
                <div class="grid-item">
                    <p>{{ calStage1DA?.StateShare_Amount }}</p>
                </div>
            </div>

            <div class="field col-12 md:col-3">
                <label>{{'ABY_AMOUNT'| translate}}</label>
                <div class="grid-item">
                    <p>{{ calStage1DA?.ABY }}</p>
                </div>
            </div>
            
            <div class="field col-12 md:col-3">
                <label>{{'TOP_UP_AMOUNT'| translate}}</label>
                <div class="grid-item">
                    <p>{{ calStage1DA?.Topup }}</p>
                </div>
            </div>

            <div class="field col-12 md:col-3">
                <label>{{'COVERAGE_AREA'| translate}}</label>
                <div class="grid-item">
                    <p>{{ calStage1DA?.Coverage_Area }}</p>
                </div>
            </div>

            <div class="field col-12 md:col-3">
                <label>{{'NO_OF_BENEFICIARY'| translate}}</label>
                <div class="grid-item">
                    <p>{{ calStage1DA?.NoOfBeneficiary }}</p>
                </div>
            </div>

            <div class="field col-12 md:col-3">
                <label>{{'VOLUME_EARTH_WORK'| translate}}</label>
                <div class="grid-item">
                    <p>{{ calStage1DA?.VolumeEarthWork }}</p>
                </div>
            </div>
            
            <div class="field col-12 md:col-3">
                <label>{{'BOTTOM_BREADTH'| translate}}</label>
                <div class="grid-item">
                    <p>{{ calStage1DA?.bottomBreadth }}</p>
                </div>
            </div>

            <div class="field col-12 md:col-3">
                <label>{{'BOTTOM_LENGTH'| translate}}</label>
                <div class="grid-item">
                    <p>{{ calStage1DA?.bottomLength }}</p>
                </div>
            </div>

            <div class="field col-12 md:col-3">
                <label>{{'BOTTOM_SIZE'| translate}}</label>
                <div class="grid-item">
                    <p>{{ calStage1DA?.bottomSize }}</p>
                </div>
            </div>

            <div class="field col-12 md:col-3">
                <label>{{'DEPTH'| translate}}</label>
                <div class="grid-item">
                    <p>{{ calStage1DA?.depth }}</p>
                </div>
            </div>

            <div class="field col-12 md:col-3">
                <label>{{'USER_ID'| translate}}</label>
                <div class="grid-item">
                    <p>{{ calStage1DA?.UserID }}</p>
                </div>
            </div>
            
            <div class="field col-12 md:col-3">
                <label>{{'ESTIMATE_COST'| translate}}</label>
                <div class="grid-item">
                    <p>{{ calStage1DA?.estimateCost }}</p>
                </div>
            </div>
            
            <div class="field col-12 md:col-3">
                <label>{{'TANK_LAT'| translate}}</label>
                <div class="grid-item">
                    <p>{{ calStage1DA?.tankLat }}</p>
                </div>
            </div>

            <div class="field col-12 md:col-3">
                <label>{{'TANK_LONG'| translate}}</label>
                <div class="grid-item">
                    <p>{{ calStage1DA?.tankLng }}</p>
                </div>
            </div>

            <div class="field col-12 md:col-3">
                <label>{{'TOP_BREADTH'| translate}}</label>
                <div class="grid-item">
                    <p>{{ calStage1DA?.topBreadth }}</p>
                </div>
            </div>

            <div class="field col-12 md:col-3">
                <label>{{'TOP_LENGTH'| translate}}</label>
                <div class="grid-item">
                    <p>{{ calStage1DA?.topLength }}</p>
                </div>
            </div>

            <div class="field col-12 md:col-3">
                <label>{{'TOP_SIZE'| translate}}</label>
                <div class="grid-item">
                    <p>{{ calStage1DA?.topSize }}</p>
                </div>
            </div>

            <div class="field col-12 md:col-3">
                <label>{{'ESTIMATE_COPY'| translate}}</label>
                <div class="grid-item">
                    <p *ngIf="calStage1DA?.MeasurementCopy">
                        <a style="cursor: pointer" [href]="calStage1DA?.MeasurementCopy"
                          target="_blank">{{'VIEW_COPY' | translate}}</a>
                      </p>
                </div>
            </div>
        </div>
    </div>
    <!-- CAL STAGE-1 DA Content End -->

    <!--  CAL STAGE-1 DMICADA Content Start -->
    <div *ngIf="calStage1DMICADA?.IsExist == 1 && calStage1DMICADA?.ActionType == 'CalcStg1_Admin'" class="card calStage1-admin-data" style="margin-bottom: 5px;">
        <div class="p-fluid p-formgrid grid justify-content-center mb-2 bold sub-heading">
            {{'CAL_STAGE1_DMICADA'| translate}}
        </div>
        <div class="p-fluid p-formgrid grid">
            <div class="field col-12 md:col-3">
                <label>{{'ACTUAL_SUBSIDY_STAGE1'| translate}}</label>
                <div class="grid-item">
                    <p>{{ calStage1DMICADA?.ActualSubsidy_Stage1 }}</p>
                </div>
            </div>

            <div class="field col-12 md:col-3">
                <label>{{'CENTER_SHARE_AMOUNT'| translate}}</label>
                <div class="grid-item">
                    <p>{{ calStage1DMICADA?.CenterShare_Amount }}</p>
                </div>
            </div>

            <div class="field col-12 md:col-3">
                <label>{{'STATE_SHARE_AMOUNT'| translate}}</label>
                <div class="grid-item">
                    <p>{{ calStage1DMICADA?.StateShare_Amount }}</p>
                </div>
            </div>

            <div class="field col-12 md:col-3">
                <label>{{'ABY_AMOUNT'| translate}}</label>
                <div class="grid-item">
                    <p>{{ calStage1DMICADA?.ABY }}</p>
                </div>
            </div>
            
            <div class="field col-12 md:col-3">
                <label>{{'TOP_UP_AMOUNT'| translate}}</label>
                <div class="grid-item">
                    <p>{{ calStage1DMICADA?.Topup }}</p>
                </div>
            </div>

            <div class="field col-12 md:col-3">
                <label>{{'COVERAGE_AREA'| translate}}</label>
                <div class="grid-item">
                    <p>{{ calStage1DMICADA?.Coverage_Area }}</p>
                </div>
            </div>

            <div class="field col-12 md:col-3">
                <label>{{'NO_OF_BENEFICIARY'| translate}}</label>
                <div class="grid-item">
                    <p>{{ calStage1DMICADA?.NoOfBeneficiary }}</p>
                </div>
            </div>

            <div class="field col-12 md:col-3">
                <label>{{'VOLUME_EARTH_WORK'| translate}}</label>
                <div class="grid-item">
                    <p>{{ calStage1DMICADA?.VolumeEarthWork }}</p>
                </div>
            </div>
            
            <div class="field col-12 md:col-3">
                <label>{{'BOTTOM_BREADTH'| translate}}</label>
                <div class="grid-item">
                    <p>{{ calStage1DMICADA?.bottomBreadth }}</p>
                </div>
            </div>

            <div class="field col-12 md:col-3">
                <label>{{'BOTTOM_LENGTH'| translate}}</label>
                <div class="grid-item">
                    <p>{{ calStage1DMICADA?.bottomLength }}</p>
                </div>
            </div>

            <div class="field col-12 md:col-3">
                <label>{{'BOTTOM_SIZE'| translate}}</label>
                <div class="grid-item">
                    <p>{{ calStage1DMICADA?.bottomSize }}</p>
                </div>
            </div>

            <div class="field col-12 md:col-3">
                <label>{{'DEPTH'| translate}}</label>
                <div class="grid-item">
                    <p>{{ calStage1DMICADA?.depth }}</p>
                </div>
            </div>

            <div class="field col-12 md:col-3">
                <label>{{'USER_ID'| translate}}</label>
                <div class="grid-item">
                    <p>{{ calStage1DMICADA?.UserID }}</p>
                </div>
            </div>
            
            <div class="field col-12 md:col-3">
                <label>{{'ESTIMATE_COST'| translate}}</label>
                <div class="grid-item">
                    <p>{{ calStage1DMICADA?.estimateCost }}</p>
                </div>
            </div>
            
            <div class="field col-12 md:col-3">
                <label>{{'TANK_LAT'| translate}}</label>
                <div class="grid-item">
                    <p>{{ calStage1DMICADA?.tankLat }}</p>
                </div>
            </div>

            <div class="field col-12 md:col-3">
                <label>{{'TANK_LONG'| translate}}</label>
                <div class="grid-item">
                    <p>{{ calStage1DMICADA?.tankLng }}</p>
                </div>
            </div>

            <div class="field col-12 md:col-3">
                <label>{{'TOP_BREADTH'| translate}}</label>
                <div class="grid-item">
                    <p>{{ calStage1DMICADA?.topBreadth }}</p>
                </div>
            </div>

            <div class="field col-12 md:col-3">
                <label>{{'TOP_LENGTH'| translate}}</label>
                <div class="grid-item">
                    <p>{{ calStage1DMICADA?.topLength }}</p>
                </div>
            </div>

            <div class="field col-12 md:col-3">
                <label>{{'TOP_SIZE'| translate}}</label>
                <div class="grid-item">
                    <p>{{ calStage1DMICADA?.topSize }}</p>
                </div>
            </div>

            <div class="field col-12 md:col-3">
                <label>{{'ESTIMATE_COPY'| translate}}</label>
                <div class="grid-item">
                    <p *ngIf="calStage1DMICADA?.MeasurementCopy">
                        <a style="cursor: pointer" [href]="calStage1DMICADA?.MeasurementCopy"
                          target="_blank">{{'VIEW_COPY' | translate}}</a>
                      </p>
                </div>
            </div>
        </div>
    </div>
    <!-- CAL STAGE-1 DMICADA Content End -->

    <!--  CAL STAGE-1 ADMIN Content Start -->
    <div *ngIf="calStage1Admin?.IsExist == 1 && calStage1Admin?.ActionType == 'CalcStg1_Admin'" class="card calStage1-admin-data" style="margin-bottom: 5px;">
        <div class="p-fluid p-formgrid grid justify-content-center mb-2 bold sub-heading">
            {{'CAL_STAGE1_ADMIN'| translate}}
        </div>
        <div class="p-fluid p-formgrid grid">
            <div class="field col-12 md:col-3">
                <label>{{'ACTUAL_SUBSIDY_STAGE1'| translate}}</label>
                <div class="grid-item">
                    <p>{{ calStage1Admin?.ActualSubsidy_Stage1 }}</p>
                </div>
            </div>

            <div class="field col-12 md:col-3">
                <label>{{'CENTER_SHARE_AMOUNT'| translate}}</label>
                <div class="grid-item">
                    <p>{{ calStage1Admin?.CenterShare_Amount }}</p>
                </div>
            </div>

            <div class="field col-12 md:col-3">
                <label>{{'STATE_SHARE_AMOUNT'| translate}}</label>
                <div class="grid-item">
                    <p>{{ calStage1Admin?.StateShare_Amount }}</p>
                </div>
            </div>

            <div class="field col-12 md:col-3">
                <label>{{'ABY_AMOUNT'| translate}}</label>
                <div class="grid-item">
                    <p>{{ calStage1Admin?.ABY }}</p>
                </div>
            </div>
            
            <div class="field col-12 md:col-3">
                <label>{{'TOP_UP_AMOUNT'| translate}}</label>
                <div class="grid-item">
                    <p>{{ calStage1Admin?.Topup }}</p>
                </div>
            </div>

            <div class="field col-12 md:col-3">
                <label>{{'COVERAGE_AREA'| translate}}</label>
                <div class="grid-item">
                    <p>{{ calStage1Admin?.Coverage_Area }}</p>
                </div>
            </div>

            <div class="field col-12 md:col-3">
                <label>{{'NO_OF_BENEFICIARY'| translate}}</label>
                <div class="grid-item">
                    <p>{{ calStage1Admin?.NoOfBeneficiary }}</p>
                </div>
            </div>

            <div class="field col-12 md:col-3">
                <label>{{'VOLUME_EARTH_WORK'| translate}}</label>
                <div class="grid-item">
                    <p>{{ calStage1Admin?.VolumeEarthWork }}</p>
                </div>
            </div>
            
            <div class="field col-12 md:col-3">
                <label>{{'BOTTOM_BREADTH'| translate}}</label>
                <div class="grid-item">
                    <p>{{ calStage1Admin?.bottomBreadth }}</p>
                </div>
            </div>

            <div class="field col-12 md:col-3">
                <label>{{'BOTTOM_LENGTH'| translate}}</label>
                <div class="grid-item">
                    <p>{{ calStage1Admin?.bottomLength }}</p>
                </div>
            </div>

            <div class="field col-12 md:col-3">
                <label>{{'BOTTOM_SIZE'| translate}}</label>
                <div class="grid-item">
                    <p>{{ calStage1Admin?.bottomSize }}</p>
                </div>
            </div>

            <div class="field col-12 md:col-3">
                <label>{{'DEPTH'| translate}}</label>
                <div class="grid-item">
                    <p>{{ calStage1Admin?.depth }}</p>
                </div>
            </div>

            <div class="field col-12 md:col-3">
                <label>{{'USER_ID'| translate}}</label>
                <div class="grid-item">
                    <p>{{ calStage1Admin?.UserID }}</p>
                </div>
            </div>
            
            <div class="field col-12 md:col-3">
                <label>{{'ESTIMATE_COST'| translate}}</label>
                <div class="grid-item">
                    <p>{{ calStage1Admin?.estimateCost }}</p>
                </div>
            </div>
            
            <div class="field col-12 md:col-3">
                <label>{{'TANK_LAT'| translate}}</label>
                <div class="grid-item">
                    <p>{{ calStage1Admin?.tankLat }}</p>
                </div>
            </div>

            <div class="field col-12 md:col-3">
                <label>{{'TANK_LONG'| translate}}</label>
                <div class="grid-item">
                    <p>{{ calStage1Admin?.tankLng }}</p>
                </div>
            </div>

            <div class="field col-12 md:col-3">
                <label>{{'TOP_BREADTH'| translate}}</label>
                <div class="grid-item">
                    <p>{{ calStage1Admin?.topBreadth }}</p>
                </div>
            </div>

            <div class="field col-12 md:col-3">
                <label>{{'TOP_LENGTH'| translate}}</label>
                <div class="grid-item">
                    <p>{{ calStage1Admin?.topLength }}</p>
                </div>
            </div>

            <div class="field col-12 md:col-3">
                <label>{{'TOP_SIZE'| translate}}</label>
                <div class="grid-item">
                    <p>{{ calStage1Admin?.topSize }}</p>
                </div>
            </div>

            <div class="field col-12 md:col-3">
                <label>{{'ESTIMATE_COPY'| translate}}</label>
                <div class="grid-item">
                    <p *ngIf="calStage1Admin?.estimateCopy">
                        <a style="cursor: pointer" [href]="calStage1Admin?.estimateCopy"
                          target="_blank">{{'VIEW_COPY' | translate}}</a>
                      </p>
                </div>
            </div>
        </div>
    </div>
    <!-- CAL STAGE-1 ADMIN Content End -->

    <!--  CAL STAGE-2 JE Content Start -->
    <div *ngIf="calStage2JE?.IsExist == 1 && calStage2JE?.ActionType == 'CalcStg2_JE'" class="card calStage2-admin-data" style="margin-bottom: 5px;">
        <div class="p-fluid p-formgrid grid justify-content-center mb-2 bold sub-heading">
            {{'CAL_STAGE2_JE'| translate}}
        </div>
        <div class="p-fluid p-formgrid grid">
            <div class="field col-12 md:col-3">
                <label>{{'ACTUAL_SUBSIDY_STAGE1'| translate}}</label>
                <div class="grid-item">
                    <p>{{ calStage2JE?.ActualSubsidy_Stage1 }}</p>
                </div>
            </div>

            <div class="field col-12 md:col-3">
                <label>{{'CENTER_SHARE_AMOUNT'| translate}}</label>
                <div class="grid-item">
                    <p>{{ calStage2JE?.CenterShare_Amount }}</p>
                </div>
            </div>

            <div class="field col-12 md:col-3">
                <label>{{'STATE_SHARE_AMOUNT'| translate}}</label>
                <div class="grid-item">
                    <p>{{ calStage2JE?.StateShare_Amount }}</p>
                </div>
            </div>

            <div class="field col-12 md:col-3">
                <label>{{'ABY_AMOUNT'| translate}}</label>
                <div class="grid-item">
                    <p>{{ calStage2JE?.ABY }}</p>
                </div>
            </div>
            
            <div class="field col-12 md:col-3">
                <label>{{'TOP_UP_AMOUNT'| translate}}</label>
                <div class="grid-item">
                    <p>{{ calStage2JE?.Topup }}</p>
                </div>
            </div>

            <div class="field col-12 md:col-3">
                <label>{{'COVERAGE_AREA'| translate}}</label>
                <div class="grid-item">
                    <p>{{ calStage2JE?.Coverage_Area }}</p>
                </div>
            </div>

            <div class="field col-12 md:col-3">
                <label>{{'NO_OF_BENEFICIARY'| translate}}</label>
                <div class="grid-item">
                    <p>{{ calStage2JE?.NoOfBeneficiary }}</p>
                </div>
            </div>

            <div class="field col-12 md:col-3">
                <label>{{'VOLUME_EARTH_WORK'| translate}}</label>
                <div class="grid-item">
                    <p>{{ calStage2JE?.VolumeEarthWork }}</p>
                </div>
            </div>
            
            <div class="field col-12 md:col-3">
                <label>{{'BOTTOM_BREADTH'| translate}}</label>
                <div class="grid-item">
                    <p>{{ calStage2JE?.bottomBreadth }}</p>
                </div>
            </div>

            <div class="field col-12 md:col-3">
                <label>{{'BOTTOM_LENGTH'| translate}}</label>
                <div class="grid-item">
                    <p>{{ calStage2JE?.bottomLength }}</p>
                </div>
            </div>

            <div class="field col-12 md:col-3">
                <label>{{'BOTTOM_SIZE'| translate}}</label>
                <div class="grid-item">
                    <p>{{ calStage2JE?.bottomSize }}</p>
                </div>
            </div>

            <div class="field col-12 md:col-3">
                <label>{{'DEPTH'| translate}}</label>
                <div class="grid-item">
                    <p>{{ calStage2JE?.depth }}</p>
                </div>
            </div>

            <div class="field col-12 md:col-3">
                <label>{{'USER_ID'| translate}}</label>
                <div class="grid-item">
                    <p>{{ calStage2JE?.UserID }}</p>
                </div>
            </div>
            
            <div class="field col-12 md:col-3">
                <label>{{'ESTIMATE_COST'| translate}}</label>
                <div class="grid-item">
                    <p>{{ calStage2JE?.estimateCost }}</p>
                </div>
            </div>
            
            <div class="field col-12 md:col-3">
                <label>{{'TANK_LAT'| translate}}</label>
                <div class="grid-item">
                    <p>{{ calStage2JE?.tankLat }}</p>
                </div>
            </div>

            <div class="field col-12 md:col-3">
                <label>{{'TANK_LONG'| translate}}</label>
                <div class="grid-item">
                    <p>{{ calStage2JE?.tankLng }}</p>
                </div>
            </div>

            <div class="field col-12 md:col-3">
                <label>{{'TOP_BREADTH'| translate}}</label>
                <div class="grid-item">
                    <p>{{ calStage2JE?.topBreadth }}</p>
                </div>
            </div>

            <div class="field col-12 md:col-3">
                <label>{{'TOP_LENGTH'| translate}}</label>
                <div class="grid-item">
                    <p>{{ calStage2JE?.topLength }}</p>
                </div>
            </div>

            <div class="field col-12 md:col-3">
                <label>{{'TOP_SIZE'| translate}}</label>
                <div class="grid-item">
                    <p>{{ calStage2JE?.topSize }}</p>
                </div>
            </div>

            <div class="field col-12 md:col-3">
                <label>{{'ESTIMATE_COPY'| translate}}</label>
                <div class="grid-item">
                    <p *ngIf="calStage2JE?.MeasurementCopy">
                        <a style="cursor: pointer" [href]="calStage2JE?.MeasurementCopy"
                          target="_blank">{{'VIEW_COPY' | translate}}</a>
                      </p>
                </div>
            </div>
        </div>
    </div>
    <!-- CAL STAGE-2 JE Content End -->

    <!--  CAL STAGE-2 DA Content Start -->
    <div *ngIf="calStage2DD?.IsExist == 1 && calStage2DD?.ActionType == 'CalcStg2_DD'" class="card calStage2-dd-data" style="margin-bottom: 5px;">
        <div class="p-fluid p-formgrid grid justify-content-center mb-2 bold sub-heading">
            {{'CAL_STAGE2_DD'| translate}}
        </div>
        <div class="p-fluid p-formgrid grid">
            <div class="field col-12 md:col-3">
                <label>{{'ACTUAL_SUBSIDY_STAGE1'| translate}}</label>
                <div class="grid-item">
                    <p>{{ calStage2DD?.ActualSubsidy_Stage1 }}</p>
                </div>
            </div>

            <div class="field col-12 md:col-3">
                <label>{{'CENTER_SHARE_AMOUNT'| translate}}</label>
                <div class="grid-item">
                    <p>{{ calStage2DD?.CenterShare_Amount }}</p>
                </div>
            </div>

            <div class="field col-12 md:col-3">
                <label>{{'STATE_SHARE_AMOUNT'| translate}}</label>
                <div class="grid-item">
                    <p>{{ calStage2DD?.StateShare_Amount }}</p>
                </div>
            </div>

            <div class="field col-12 md:col-3">
                <label>{{'ABY_AMOUNT'| translate}}</label>
                <div class="grid-item">
                    <p>{{ calStage2DD?.ABY }}</p>
                </div>
            </div>
            
            <div class="field col-12 md:col-3">
                <label>{{'TOP_UP_AMOUNT'| translate}}</label>
                <div class="grid-item">
                    <p>{{ calStage2DD?.Topup }}</p>
                </div>
            </div>

            <div class="field col-12 md:col-3">
                <label>{{'COVERAGE_AREA'| translate}}</label>
                <div class="grid-item">
                    <p>{{ calStage2DD?.Coverage_Area }}</p>
                </div>
            </div>

            <div class="field col-12 md:col-3">
                <label>{{'NO_OF_BENEFICIARY'| translate}}</label>
                <div class="grid-item">
                    <p>{{ calStage2DD?.NoOfBeneficiary }}</p>
                </div>
            </div>

            <div class="field col-12 md:col-3">
                <label>{{'VOLUME_EARTH_WORK'| translate}}</label>
                <div class="grid-item">
                    <p>{{ calStage2DD?.VolumeEarthWork }}</p>
                </div>
            </div>
            
            <div class="field col-12 md:col-3">
                <label>{{'BOTTOM_BREADTH'| translate}}</label>
                <div class="grid-item">
                    <p>{{ calStage2DD?.bottomBreadth }}</p>
                </div>
            </div>

            <div class="field col-12 md:col-3">
                <label>{{'BOTTOM_LENGTH'| translate}}</label>
                <div class="grid-item">
                    <p>{{ calStage2DD?.bottomLength }}</p>
                </div>
            </div>

            <div class="field col-12 md:col-3">
                <label>{{'BOTTOM_SIZE'| translate}}</label>
                <div class="grid-item">
                    <p>{{ calStage2DD?.bottomSize }}</p>
                </div>
            </div>

            <div class="field col-12 md:col-3">
                <label>{{'DEPTH'| translate}}</label>
                <div class="grid-item">
                    <p>{{ calStage2DD?.depth }}</p>
                </div>
            </div>

            <div class="field col-12 md:col-3">
                <label>{{'USER_ID'| translate}}</label>
                <div class="grid-item">
                    <p>{{ calStage2DD?.UserID }}</p>
                </div>
            </div>
            
            <div class="field col-12 md:col-3">
                <label>{{'ESTIMATE_COST'| translate}}</label>
                <div class="grid-item">
                    <p>{{ calStage2DD?.estimateCost }}</p>
                </div>
            </div>
            
            <div class="field col-12 md:col-3">
                <label>{{'TANK_LAT'| translate}}</label>
                <div class="grid-item">
                    <p>{{ calStage2DD?.tankLat }}</p>
                </div>
            </div>

            <div class="field col-12 md:col-3">
                <label>{{'TANK_LONG'| translate}}</label>
                <div class="grid-item">
                    <p>{{ calStage2DD?.tankLng }}</p>
                </div>
            </div>

            <div class="field col-12 md:col-3">
                <label>{{'TOP_BREADTH'| translate}}</label>
                <div class="grid-item">
                    <p>{{ calStage2DD?.topBreadth }}</p>
                </div>
            </div>

            <div class="field col-12 md:col-3">
                <label>{{'TOP_LENGTH'| translate}}</label>
                <div class="grid-item">
                    <p>{{ calStage2DD?.topLength }}</p>
                </div>
            </div>

            <div class="field col-12 md:col-3">
                <label>{{'TOP_SIZE'| translate}}</label>
                <div class="grid-item">
                    <p>{{ calStage2DD?.topSize }}</p>
                </div>
            </div>

            <div class="field col-12 md:col-3">
                <label>{{'ESTIMATE_COPY'| translate}}</label>
                <div class="grid-item">
                    <p *ngIf="calStage2DD?.MeasurementCopy">
                        <a style="cursor: pointer" [href]="calStage2DD?.MeasurementCopy"
                          target="_blank">{{'VIEW_COPY' | translate}}</a>
                      </p>
                </div>
            </div>
        </div>
    </div>
    <!-- CAL STAGE-2 DA Content End -->


    <!--  CAL STAGE-2 DA Content Start -->
    <div *ngIf="calStage2DA?.IsExist == 1 && calStage2DA?.ActionType == 'CalcStg2_DA'" class="card calStage2-da-data" style="margin-bottom: 5px;">
        <div class="p-fluid p-formgrid grid justify-content-center mb-2 bold sub-heading">
            {{'CAL_STAGE2_DA'| translate}}
        </div>
        <div class="p-fluid p-formgrid grid">
            <div class="field col-12 md:col-3">
                <label>{{'ACTUAL_SUBSIDY_STAGE1'| translate}}</label>
                <div class="grid-item">
                    <p>{{ calStage2DA?.ActualSubsidy_Stage1 }}</p>
                </div>
            </div>

            <div class="field col-12 md:col-3">
                <label>{{'CENTER_SHARE_AMOUNT'| translate}}</label>
                <div class="grid-item">
                    <p>{{ calStage2DA?.CenterShare_Amount }}</p>
                </div>
            </div>

            <div class="field col-12 md:col-3">
                <label>{{'STATE_SHARE_AMOUNT'| translate}}</label>
                <div class="grid-item">
                    <p>{{ calStage2DA?.StateShare_Amount }}</p>
                </div>
            </div>

            <div class="field col-12 md:col-3">
                <label>{{'ABY_AMOUNT'| translate}}</label>
                <div class="grid-item">
                    <p>{{ calStage2DA?.ABY }}</p>
                </div>
            </div>
            
            <div class="field col-12 md:col-3">
                <label>{{'TOP_UP_AMOUNT'| translate}}</label>
                <div class="grid-item">
                    <p>{{ calStage2DA?.Topup }}</p>
                </div>
            </div>

            <div class="field col-12 md:col-3">
                <label>{{'COVERAGE_AREA'| translate}}</label>
                <div class="grid-item">
                    <p>{{ calStage2DA?.Coverage_Area }}</p>
                </div>
            </div>

            <div class="field col-12 md:col-3">
                <label>{{'NO_OF_BENEFICIARY'| translate}}</label>
                <div class="grid-item">
                    <p>{{ calStage2DA?.NoOfBeneficiary }}</p>
                </div>
            </div>

            <div class="field col-12 md:col-3">
                <label>{{'VOLUME_EARTH_WORK'| translate}}</label>
                <div class="grid-item">
                    <p>{{ calStage2DA?.VolumeEarthWork }}</p>
                </div>
            </div>
            
            <div class="field col-12 md:col-3">
                <label>{{'BOTTOM_BREADTH'| translate}}</label>
                <div class="grid-item">
                    <p>{{ calStage2DA?.bottomBreadth }}</p>
                </div>
            </div>

            <div class="field col-12 md:col-3">
                <label>{{'BOTTOM_LENGTH'| translate}}</label>
                <div class="grid-item">
                    <p>{{ calStage2DA?.bottomLength }}</p>
                </div>
            </div>

            <div class="field col-12 md:col-3">
                <label>{{'BOTTOM_SIZE'| translate}}</label>
                <div class="grid-item">
                    <p>{{ calStage2DA?.bottomSize }}</p>
                </div>
            </div>

            <div class="field col-12 md:col-3">
                <label>{{'DEPTH'| translate}}</label>
                <div class="grid-item">
                    <p>{{ calStage2DA?.depth }}</p>
                </div>
            </div>

            <div class="field col-12 md:col-3">
                <label>{{'USER_ID'| translate}}</label>
                <div class="grid-item">
                    <p>{{ calStage2DA?.UserID }}</p>
                </div>
            </div>
            
            <div class="field col-12 md:col-3">
                <label>{{'ESTIMATE_COST'| translate}}</label>
                <div class="grid-item">
                    <p>{{ calStage2DA?.estimateCost }}</p>
                </div>
            </div>
            
            <div class="field col-12 md:col-3">
                <label>{{'TANK_LAT'| translate}}</label>
                <div class="grid-item">
                    <p>{{ calStage2DA?.tankLat }}</p>
                </div>
            </div>

            <div class="field col-12 md:col-3">
                <label>{{'TANK_LONG'| translate}}</label>
                <div class="grid-item">
                    <p>{{ calStage2DA?.tankLng }}</p>
                </div>
            </div>

            <div class="field col-12 md:col-3">
                <label>{{'TOP_BREADTH'| translate}}</label>
                <div class="grid-item">
                    <p>{{ calStage2DA?.topBreadth }}</p>
                </div>
            </div>

            <div class="field col-12 md:col-3">
                <label>{{'TOP_LENGTH'| translate}}</label>
                <div class="grid-item">
                    <p>{{ calStage2DA?.topLength }}</p>
                </div>
            </div>

            <div class="field col-12 md:col-3">
                <label>{{'TOP_SIZE'| translate}}</label>
                <div class="grid-item">
                    <p>{{ calStage2DA?.topSize }}</p>
                </div>
            </div>

            <div class="field col-12 md:col-3">
                <label>{{'ESTIMATE_COPY'| translate}}</label>
                <div class="grid-item">
                    <p *ngIf="calStage2DA?.MeasurementCopy">
                        <a style="cursor: pointer" [href]="calStage2DA?.MeasurementCopy"
                          target="_blank">{{'VIEW_COPY' | translate}}</a>
                      </p>
                </div>
            </div>
        </div>
    </div>
    <!-- CAL STAGE-2 DA Content End -->

    <!--  CAL STAGE-2 DMICADA Content Start -->
    <div *ngIf="calStage2DMICADA?.IsExist == 1 && calStage2DMICADA?.ActionType == 'CalcStg2_DMICADA'" class="card calStage2-admin-data" style="margin-bottom: 5px;">
        <div class="p-fluid p-formgrid grid justify-content-center mb-2 bold sub-heading">
            {{'CAL_STAGE2_DMICADA'| translate}}
        </div>
        <div class="p-fluid p-formgrid grid">
            <div class="field col-12 md:col-3">
                <label>{{'ACTUAL_SUBSIDY_STAGE1'| translate}}</label>
                <div class="grid-item">
                    <p>{{ calStage2DMICADA?.ActualSubsidy_Stage1 }}</p>
                </div>
            </div>

            <div class="field col-12 md:col-3">
                <label>{{'CENTER_SHARE_AMOUNT'| translate}}</label>
                <div class="grid-item">
                    <p>{{ calStage2DMICADA?.CenterShare_Amount }}</p>
                </div>
            </div>

            <div class="field col-12 md:col-3">
                <label>{{'STATE_SHARE_AMOUNT'| translate}}</label>
                <div class="grid-item">
                    <p>{{ calStage2DMICADA?.StateShare_Amount }}</p>
                </div>
            </div>

            <div class="field col-12 md:col-3">
                <label>{{'ABY_AMOUNT'| translate}}</label>
                <div class="grid-item">
                    <p>{{ calStage2DMICADA?.ABY }}</p>
                </div>
            </div>
            
            <div class="field col-12 md:col-3">
                <label>{{'TOP_UP_AMOUNT'| translate}}</label>
                <div class="grid-item">
                    <p>{{ calStage2DMICADA?.Topup }}</p>
                </div>
            </div>

            <div class="field col-12 md:col-3">
                <label>{{'COVERAGE_AREA'| translate}}</label>
                <div class="grid-item">
                    <p>{{ calStage2DMICADA?.Coverage_Area }}</p>
                </div>
            </div>

            <div class="field col-12 md:col-3">
                <label>{{'NO_OF_BENEFICIARY'| translate}}</label>
                <div class="grid-item">
                    <p>{{ calStage2DMICADA?.NoOfBeneficiary }}</p>
                </div>
            </div>

            <div class="field col-12 md:col-3">
                <label>{{'VOLUME_EARTH_WORK'| translate}}</label>
                <div class="grid-item">
                    <p>{{ calStage2DMICADA?.VolumeEarthWork }}</p>
                </div>
            </div>
            
            <div class="field col-12 md:col-3">
                <label>{{'BOTTOM_BREADTH'| translate}}</label>
                <div class="grid-item">
                    <p>{{ calStage2DMICADA?.bottomBreadth }}</p>
                </div>
            </div>

            <div class="field col-12 md:col-3">
                <label>{{'BOTTOM_LENGTH'| translate}}</label>
                <div class="grid-item">
                    <p>{{ calStage2DMICADA?.bottomLength }}</p>
                </div>
            </div>

            <div class="field col-12 md:col-3">
                <label>{{'BOTTOM_SIZE'| translate}}</label>
                <div class="grid-item">
                    <p>{{ calStage2DMICADA?.bottomSize }}</p>
                </div>
            </div>

            <div class="field col-12 md:col-3">
                <label>{{'DEPTH'| translate}}</label>
                <div class="grid-item">
                    <p>{{ calStage2DMICADA?.depth }}</p>
                </div>
            </div>

            <div class="field col-12 md:col-3">
                <label>{{'USER_ID'| translate}}</label>
                <div class="grid-item">
                    <p>{{ calStage2DMICADA?.UserID }}</p>
                </div>
            </div>
            
            <div class="field col-12 md:col-3">
                <label>{{'ESTIMATE_COST'| translate}}</label>
                <div class="grid-item">
                    <p>{{ calStage2DMICADA?.estimateCost }}</p>
                </div>
            </div>
            
            <div class="field col-12 md:col-3">
                <label>{{'TANK_LAT'| translate}}</label>
                <div class="grid-item">
                    <p>{{ calStage2DMICADA?.tankLat }}</p>
                </div>
            </div>

            <div class="field col-12 md:col-3">
                <label>{{'TANK_LONG'| translate}}</label>
                <div class="grid-item">
                    <p>{{ calStage2DMICADA?.tankLng }}</p>
                </div>
            </div>

            <div class="field col-12 md:col-3">
                <label>{{'TOP_BREADTH'| translate}}</label>
                <div class="grid-item">
                    <p>{{ calStage2DMICADA?.topBreadth }}</p>
                </div>
            </div>

            <div class="field col-12 md:col-3">
                <label>{{'TOP_LENGTH'| translate}}</label>
                <div class="grid-item">
                    <p>{{ calStage2DMICADA?.topLength }}</p>
                </div>
            </div>

            <div class="field col-12 md:col-3">
                <label>{{'TOP_SIZE'| translate}}</label>
                <div class="grid-item">
                    <p>{{ calStage2DMICADA?.topSize }}</p>
                </div>
            </div>

            <div class="field col-12 md:col-3">
                <label>{{'ESTIMATE_COPY'| translate}}</label>
                <div class="grid-item">
                    <p *ngIf="calStage2DMICADA?.MeasurementCopy">
                        <a style="cursor: pointer" [href]="calStage2DMICADA?.MeasurementCopy"
                          target="_blank">{{'VIEW_COPY' | translate}}</a>
                      </p>
                </div>
            </div>
        </div>
    </div>
    <!-- CAL STAGE-2 DMICADA Content End -->

    <!--  CAL STAGE-2 ADMIN Content Start -->
    <div *ngIf="calStage2Admin?.IsExist == 1 && calStage2Admin?.ActionType == 'CalcStg2_Admin'" class="card calStage2-admin-data" style="margin-bottom: 5px;">
        <div class="p-fluid p-formgrid grid justify-content-center mb-2 bold sub-heading">
            {{'CAL_STAGE2_ADMIN'| translate}}
        </div>
        <div class="p-fluid p-formgrid grid">
            <div class="field col-12 md:col-3">
                <label>{{'ACTUAL_SUBSIDY_STAGE1'| translate}}</label>
                <div class="grid-item">
                    <p>{{ calStage2Admin?.ActualSubsidy_Stage1 }}</p>
                </div>
            </div>

            <div class="field col-12 md:col-3">
                <label>{{'CENTER_SHARE_AMOUNT'| translate}}</label>
                <div class="grid-item">
                    <p>{{ calStage2Admin?.CenterShare_Amount }}</p>
                </div>
            </div>

            <div class="field col-12 md:col-3">
                <label>{{'STATE_SHARE_AMOUNT'| translate}}</label>
                <div class="grid-item">
                    <p>{{ calStage2Admin?.StateShare_Amount }}</p>
                </div>
            </div>

            <div class="field col-12 md:col-3">
                <label>{{'ABY_AMOUNT'| translate}}</label>
                <div class="grid-item">
                    <p>{{ calStage2Admin?.ABY }}</p>
                </div>
            </div>
            
            <div class="field col-12 md:col-3">
                <label>{{'TOP_UP_AMOUNT'| translate}}</label>
                <div class="grid-item">
                    <p>{{ calStage2Admin?.Topup }}</p>
                </div>
            </div>

            <div class="field col-12 md:col-3">
                <label>{{'COVERAGE_AREA'| translate}}</label>
                <div class="grid-item">
                    <p>{{ calStage2Admin?.Coverage_Area }}</p>
                </div>
            </div>

            <div class="field col-12 md:col-3">
                <label>{{'NO_OF_BENEFICIARY'| translate}}</label>
                <div class="grid-item">
                    <p>{{ calStage2Admin?.NoOfBeneficiary }}</p>
                </div>
            </div>

            <div class="field col-12 md:col-3">
                <label>{{'VOLUME_EARTH_WORK'| translate}}</label>
                <div class="grid-item">
                    <p>{{ calStage2Admin?.VolumeEarthWork }}</p>
                </div>
            </div>
            
            <div class="field col-12 md:col-3">
                <label>{{'BOTTOM_BREADTH'| translate}}</label>
                <div class="grid-item">
                    <p>{{ calStage2Admin?.bottomBreadth }}</p>
                </div>
            </div>

            <div class="field col-12 md:col-3">
                <label>{{'BOTTOM_LENGTH'| translate}}</label>
                <div class="grid-item">
                    <p>{{ calStage2Admin?.bottomLength }}</p>
                </div>
            </div>

            <div class="field col-12 md:col-3">
                <label>{{'BOTTOM_SIZE'| translate}}</label>
                <div class="grid-item">
                    <p>{{ calStage2Admin?.bottomSize }}</p>
                </div>
            </div>

            <div class="field col-12 md:col-3">
                <label>{{'DEPTH'| translate}}</label>
                <div class="grid-item">
                    <p>{{ calStage2Admin?.depth }}</p>
                </div>
            </div>

            <div class="field col-12 md:col-3">
                <label>{{'USER_ID'| translate}}</label>
                <div class="grid-item">
                    <p>{{ calStage2Admin?.UserID }}</p>
                </div>
            </div>
            
            <div class="field col-12 md:col-3">
                <label>{{'ESTIMATE_COST'| translate}}</label>
                <div class="grid-item">
                    <p>{{ calStage2Admin?.estimateCost }}</p>
                </div>
            </div>
            
            <div class="field col-12 md:col-3">
                <label>{{'TANK_LAT'| translate}}</label>
                <div class="grid-item">
                    <p>{{ calStage2Admin?.tankLat }}</p>
                </div>
            </div>

            <div class="field col-12 md:col-3">
                <label>{{'TANK_LONG'| translate}}</label>
                <div class="grid-item">
                    <p>{{ calStage2Admin?.tankLng }}</p>
                </div>
            </div>

            <div class="field col-12 md:col-3">
                <label>{{'TOP_BREADTH'| translate}}</label>
                <div class="grid-item">
                    <p>{{ calStage2Admin?.topBreadth }}</p>
                </div>
            </div>

            <div class="field col-12 md:col-3">
                <label>{{'TOP_LENGTH'| translate}}</label>
                <div class="grid-item">
                    <p>{{ calStage2Admin?.topLength }}</p>
                </div>
            </div>

            <div class="field col-12 md:col-3">
                <label>{{'TOP_SIZE'| translate}}</label>
                <div class="grid-item">
                    <p>{{ calStage2Admin?.topSize }}</p>
                </div>
            </div>

            <div class="field col-12 md:col-3">
                <label>{{'ESTIMATE_COPY'| translate}}</label>
                <div class="grid-item">
                    <p *ngIf="calStage2Admin?.MeasurementCopy">
                        <a style="cursor: pointer" [href]="calStage2Admin?.MeasurementCopy"
                          target="_blank">{{'VIEW_COPY' | translate}}</a>
                      </p>
                </div>
            </div>
        </div>
    </div>
    <!-- CAL STAGE-2 ADMIN Content End -->


    <!-- remarks start -->
    <div *ngIf="remarksData" class="card remarks-data" style="margin-bottom: 5px;">
        <div class="p-fluid p-formgrid grid justify-content-center mb-2 bold sub-heading">
            {{'REMARKS'| translate}}
        </div>
        <div class="p-fluid p-formgrid grid">
            <div *ngIf="remarksData?.JERemarks_Stg1" class="field col-12 md:col-3">
                <label>{{'JE_REMARK_STAGE1'| translate}}</label>
                <div class="grid-item">
                    <p>{{ remarksData?.JERemarks_Stg1 }}</p>
                </div>
            </div>
            <div *ngIf="remarksData?.JERemarks_Stg2" class="field col-12 md:col-3">
                <label>{{'JE_REMARK_STAGE2'| translate}}</label>
                <div class="grid-item">
                    <p>{{ remarksData?.JERemarks_Stg2 }}</p>
                </div>
            </div>
            <div *ngIf="remarksData?.JE_EW_Remarks_CalcStg1" class="field col-12 md:col-3">
                <label>{{'JE_REMARK_CALC_STAGE21'| translate}}</label>
                <div class="grid-item">
                    <p>{{ remarksData?.JE_EW_Remarks_CalcStg1 }}</p>
                </div>
            </div>
            <div *ngIf="remarksData?.JERemarks_CalcStg2" class="field col-12 md:col-3">
                <label>{{'JE_REMARK_CALC_STAGE2'| translate}}</label>
                <div class="grid-item">
                    <p>{{ remarksData?.JERemarks_CalcStg2 }}</p>
                </div>
            </div>

            <div *ngIf="remarksData?.XENRemarks_Stg1" class="field col-12 md:col-3">
                <label>{{'XEN_REMARK_STAGE1'| translate}}</label>
                <div class="grid-item">
                    <p>{{ remarksData?.XENRemarks_Stg1 }}</p>
                </div>
            </div>
            <div *ngIf="remarksData?.XENRemarks_Stg2" class="field col-12 md:col-3">
                <label>{{'XEN_REMARK_STAGE2'| translate}}</label>
                <div class="grid-item">
                    <p>{{ remarksData?.XENRemarks_Stg2 }}</p>
                </div>
            </div>


            <div *ngIf="remarksData?.DARemarks_Stg1" class="field col-12 md:col-3">
                <label>{{'DA_REMARK_STAGE1'| translate}}</label>
                <div class="grid-item">
                    <p>{{ remarksData?.DARemarks_Stg1 }}</p>
                </div>
            </div>
            <div *ngIf="remarksData?.DARemarks_Stg2" class="field col-12 md:col-3">
                <label>{{'DA_REMARK_STAGE2'| translate}}</label>
                <div class="grid-item">
                    <p>{{ remarksData?.DARemarks_Stg2 }}</p>
                </div>
            </div>
            <div *ngIf="remarksData?.DARemarks_Stg1" class="field col-12 md:col-3">
                <label>{{'DA_REMARK_CALC_STAGE1'| translate}}</label>
                <div class="grid-item">
                    <p>{{ remarksData?.DARemarks_Stg1 }}</p>
                </div>
            </div>
            <div *ngIf="remarksData?.DERemarks_CalcStg2" class="field col-12 md:col-3">
                <label>{{'DA_REMARK_CALC_STAGE2'| translate}}</label>
                <div class="grid-item">
                    <p>{{ remarksData?.DERemarks_CalcStg2 }}</p>
                </div>
            </div>

            <div *ngIf="remarksData?.DMICADAReamrks" class="field col-12 md:col-3">
                <label>{{'DMICADA_REMARK'| translate}}</label>
                <div class="grid-item">
                    <p>{{ remarksData?.DMICADAReamrks }}</p>
                </div>
            </div>
            <div *ngIf="remarksData?.DMICADAReamrks_Stg1" class="field col-12 md:col-3">
                <label>{{'DMICADA_REMARK_STAGE2'| translate}}</label>
                <div class="grid-item">
                    <p>{{ remarksData?.DMICADAReamrks_Stg1 }}</p>
                </div>
            </div>

            <div *ngIf="remarksData?.AdminRemarks" class="field col-12 md:col-3">
                <label>{{'ADMIN_REMARK'| translate}}</label>
                <div class="grid-item">
                    <p>{{ remarksData?.AdminRemarks }}</p>
                </div>
            </div>
            <div *ngIf="remarksData?.AdminRemarks_Stg1" class="field col-12 md:col-3">
                <label>{{'ADMIN_REMARK__STAGE1'| translate}}</label>
                <div class="grid-item">
                    <p>{{ remarksData?.AdminRemarks_Stg1 }}</p>
                </div>
            </div>
        </div>
    </div>
    <!-- remarks end -->


    <!-- <div class="app-verification-container">
        <h4>List Of Water Tank To Be Verified (PFMS Module)</h4>
        <div class="col-12">
            <div class="card hidden-xs to-print" id="printableArea" reflow="true">
                <div class="consent-form border">

                    Stage 3 details start
                    <ng-container>
                        <div class="print border bold">
                            {{'SURVEY_STAGE1_JE'| translate}}
                        </div>
                        <div class="table">
                            <table class="border">
                                <tr>
                                    <td>
                                        <p class="bold">{{'COLUMN1'| translate}}: {{ pondVerData?.Column1 }}</p>
                                    </td>
                                    <td>
                                        <p class="bold">{{'COLUMN2'| translate}}: {{ pondVerData?.Column2 }}</p>
                                    </td>
                                    <td>
                                        <p class="bold">{{'COLUMN3'| translate}}: {{ pondVerData?.Column3 }}</p>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <p class="bold">{{'COLUMN4'| translate}}: {{ pondVerData?.Column4 }}</p>
                                    </td>
                                    <td>
                                        <p class="bold">{{'COLUMN5'| translate}}: {{ pondVerData?.Column5 }}</p>
                                    </td>
                                    <td>
                                        <p class="bold">{{'COLUMN6'| translate}}: {{ pondVerData?.Column6 }}</p>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <p class="bold">{{'COLUMN7'| translate}}: {{ pondVerData?.Column7 }}</p>
                                    </td>
                                    <td>
                                        <p class="bold">{{'COLUMN8'| translate}}: {{ pondVerData?.Column8 }}</p>
                                    </td>
                                    <td>
                                        <p class="bold">{{'COLUMN9'| translate}}: {{ pondVerData?.Column9 }}</p>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <p class="bold">{{'COLUMN10'| translate}}: {{ pondVerData?.Column1 }}</p>
                                    </td>
                                    <td>
                                        <p class="bold">{{'COLUMN11'| translate}}: {{ pondVerData?.Column2 }}</p>
                                    </td>
                                    <td>
                                        <p class="bold">{{'COLUMN3'| translate}}: {{ pondVerData?.Column3 }}</p>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <p class="bold">{{'DEPTH'| translate}}</p>
                                        <p>
                                            {{ pondVerData?.depth }}
                                        </p>
                                    </td>
                                    <td>
                                        <p class="bold">{{'TANK_LAT'| translate}}</p>
                                        <p>
                                            {{ pondVerData?.tankLat }}
                                        </p>
                                    </td>
                                    <td>
                                        <p class="bold">{{'TANK_LONG'| translate}}</p>
                                        <p>
                                            {{ pondVerData?.tankLng }}
                                        </p>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <p class="bold">{{'MEASUREMENT_COPY'| translate}}</p>
                                        <p>
                                            {{ pondVerData?.MeasurementCopy }}
                                        </p>
                                    </td>
                                    <td>
                                        <p class="bold">{{'ESTIMATE_COPY_STAGE1'| translate}}</p>
                                        <p>
                                            {{ pondVerData?.estimateCopy_Stage1 }}
                                        </p>
                                    </td>
                                    <td>
                                        <p class="bold">{{'ACTUAL_SUBSIDY_AREA_IS_REQUIRED'| translate}}</p>
                                        <p>
                                            {{ pondVerData?.AssistancePaidAtStage1 }}
                                        </p>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <p class="bold">{{'ACTUAL_SUBSIDY_STAGE1'| translate}}</p>
                                        <p>
                                            {{ pondVerData?.ActualSubsidy_Stage1 }}
                                        </p>
                                    </td>
                                    <td>
                                        <p class="bold">{{'ACTUAL_SUBSIDY_STAGE2'| translate}}</p>
                                        <p>
                                            {{ pondVerData?.ActualSubsidy_Stage2 }}
                                        </p>
                                    </td>
                                </tr>
                            </table>
                        </div>
                    </ng-container>
                </div>
            </div>
        </div>
    </div> -->
    <div class="card dropdown-content">
        <p-toolbar styleClass="mb-4">
            <ng-template pTemplate="left">
                <div class="p-fluid p-formgrid grid">
                    <div class="field col-12 md:col-3">
                        <label htmlFor="StateShare_Amount">{{'ACTUAL_SUBSIDY_STAGE3'| translate}}:
                        </label>
                        <p-inputNumber [(ngModel)]="actualSubsidyStage3" readOnly mode="decimal" [minFractionDigits]="2" [maxFractionDigits]="2" class="mr-3" 
                            [ngClass]="{'ng-invalid ng-dirty': isSubmitted && actualSubsidyStage3 == undefined}"></p-inputNumber>
                            <div *ngIf="isSubmitted && actualSubsidyStage3 == undefined" class="invalid-feedback">
                                <div>{{'ACTUAL_SUBSIDY_AREA_IS_REQUIRED' | translate}}</div>
                            </div>
                    </div>
                    <div class="field col-12 md:col-3">
                        <label htmlFor="StateShare_Amount">{{'STATE_SHARE_PAYMENT_AMOUNT'| translate}}:
                        </label>
                        <input readonly [(ngModel)]="StateShare_Amount"  pInputText id="StateShare_Amount"
                            type="number" placeholder="State Share Amount"/>
                    </div>
                    <div class="field col-12 md:col-3">
                        <label htmlFor="CenterShare_Amount">{{'CENTER_SHARE_PAYMENT_AMOUNT'| translate}}:
                        </label>
                        <input readonly [(ngModel)]="CenterShare_Amount"  pInputText id="CenterShare_Amount"
                            type="number" placeholder="Center Share Amount"/>
                    </div>
                    <div class="field col-12 md:col-3">
                        <label htmlFor="TopUp">{{'TOP_UP_AMOUNT'| translate}}:
                        </label>
                        <input readonly [(ngModel)]="TopUp_Amount"  pInputText id="TopUp"
                        type="number" placeholder="Top Up Amount"/>
                    </div>
                    <div class="field col-12 md:col-3">
                        <label htmlFor="ABY">{{'ABY_AMOUNT'| translate}}:
                        </label>
                        <input readonly [(ngModel)]="ABY_Amount"  pInputText id="ABY"
                            type="number" placeholder="ABY Amount"/>
                    </div>
                    <div class="field col-12 md:col-3">
                        <label htmlFor="ABY">{{'ACTION'| translate}}:
                        </label>
                        <p-dropdown [options]="items" [(ngModel)]="selectedStatus" optionLabel="status"
                        class="mr-3"></p-dropdown>
                    </div>
                    <div class="field col-12 md:col-3">
                        <textarea id="description" [(ngModel)]="remarks" placeholder="Remarks" pInputTextarea required rows="3"
                        cols="20" class="mr-3"></textarea>
                    </div>
                    <div class="field col-12 md:col-2">
                        <button pButton pRipple label="Submit" (click)="handleClick()" class="p-button-help"></button>
                    </div>
                </div>
            </ng-template>
            <!-- <ng-template pTemplate="right">
                <p-dropdown [options]="items" [(ngModel)]="selectedStatus" optionLabel="status"
                    class="mr-3"></p-dropdown>
                <textarea id="description" [(ngModel)]="remarks" placeholder="Remarks" pInputTextarea required rows="3"
                    cols="20" class="mr-3"></textarea>
                <button pButton pRipple label="Submit" (click)="handleClick()" class="p-button-help"></button>
            </ng-template> -->
        </p-toolbar>
    </div>

    <div class="card mt-3" reflow="true">
        <div *ngIf="viewWorkFlowAllStatus">
            <app-work-flow-all-status [applicationId]="selectedApplication?.appID"></app-work-flow-all-status>
        </div>
        <button *ngIf="!viewWorkFlowAllStatus" pButton type="button" label="{{'VIEW_APPLICATION_STATUS' | translate}}"
            class="p-button-secondary" (click)="workFlowAllStatus()"></button>
    </div>
</p-dialog>